import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { memo, createContext, useState, useEffect, useRef, useMemo, createElement, useContext, useCallback } from 'react';
import { DialogWithHeader, tailwindHelpers, Label, Input, LabelWithFlagSuccess, ChipSelection, Checkbox, CheckboxItem, DialogSuccess, useCookiesState, ReactPortalComponent, useCookieStateWithEncryption, useStorageStateWithEncryption, useAsyncModal, getCookie, useOnClickOutside } from '@r123/ui';
import { debounce } from 'lodash';
import { useForm } from 'react-hook-form';

// src/Loader.tsx
var Loader = () => {
  return /* @__PURE__ */ jsx("span", { className: "animate-spin block mx-auto w-6 aspect-square rounded-full border-[3px] border-solid border-[#8da1d7] border-r-white" });
};
var Loader_default = Loader;

// src/constant.ts
var phoneNumbers = [
  {
    label: "Indonesia",
    value: "+62"
  },
  {
    label: "Algeria",
    value: "+213"
  },
  {
    label: "Argentina",
    value: "+54"
  },
  {
    label: "Australia",
    value: "+61"
  },
  {
    label: "Bahrain",
    value: "+973"
  },
  {
    label: "Bangladesh",
    value: "+880"
  },
  {
    label: "Brazil",
    value: "+55"
  },
  {
    label: "Cambodia",
    value: "+855"
  },
  {
    label: "Canada",
    value: "+1"
  },
  {
    label: "China",
    value: "+86"
  },
  {
    label: "Egypt",
    value: "+20"
  },
  {
    label: "Guinea",
    value: "+224"
  },
  {
    label: "India",
    value: "+91"
  },
  {
    label: "Iraq",
    value: "+964"
  },
  {
    label: "Jamaica",
    value: "+1 876"
  },
  {
    label: "Japan",
    value: "+81"
  },
  {
    label: "Jordan",
    value: "+962"
  },
  {
    label: "Kenya",
    value: "+254"
  },
  {
    label: "Kuwait",
    value: "+965"
  },
  {
    label: "Lebanon",
    value: "+961"
  },
  {
    label: "Malaysia",
    value: "+60"
  },
  {
    label: "Maldives",
    value: "+960"
  },
  {
    label: "Mexico",
    value: "+52"
  },
  {
    label: "Morocco",
    value: "+212"
  },
  {
    label: "Nigeria",
    value: "+234"
  },
  {
    label: "Pakistan",
    value: "+92"
  },
  {
    label: "Panama",
    value: "+507"
  },
  {
    label: "Papua New Guinea",
    value: "+675"
  },
  {
    label: "Philippines",
    value: "+63"
  },
  {
    label: "Qatar",
    value: "+974"
  },
  {
    label: "Saudi Arabia",
    value: "+966"
  },
  {
    label: "Senegal",
    value: "+221"
  },
  {
    label: "Singapore",
    value: "+65"
  },
  {
    label: "South Africa",
    value: "+27"
  },
  {
    label: "Thailand",
    value: "+66"
  },
  {
    label: "Turkey",
    value: "+90"
  },
  {
    label: "United Arab Emirates",
    value: "+971"
  },
  {
    label: "United States",
    value: "+1"
  },
  {
    label: "Brunei Darussalam",
    value: "+673"
  },
  {
    label: "Hong Kong",
    value: "+852"
  },
  {
    label: "Iran, Islamic Republic of",
    value: "+98"
  },
  {
    label: "Macao",
    value: "+853"
  },
  {
    label: "Taiwan, Province of China",
    value: "+886"
  },
  {
    label: "Timor-Leste",
    value: "+670"
  },
  {
    label: "Viet Nam",
    value: "+84"
  }
];
var OTP_ENQUIRY_COOKIE_KEY = "enquiry_data";
var OTP_ENQUIRY_MAIN_COOKIE_KEY = "em";
var OTP_MORTGAGE_ENQUIRY_COOKIE_KEY = "emd";
var OTP_NUMBER_LENGTH = 6;
var ENQUIRY_COOKIES_EXPIRE_DURATION = 34473600 * 1e3;
var DEFAULT_OTP_ENQUIRY_COOKIE_VALUE = {
  name: "",
  phoneNumber: "",
  email: "",
  requestId: "",
  requestOTPTime: 0,
  isVerified: false,
  enquiryCount: 0,
  isEverSubmitNPS: false,
  isEverTickMortgage: false
};
var DEFAULT_ENQUIRY_MAIN_COOKIE_VALUE = {
  name: "",
  phoneNumber: "",
  isVerified: false
};
var DEFAULT_MORTGAGE_ENQUIRY_COOKIE_VALUE = {};
var TRANSLATION = {
  id: {
    question: "Pertanyaan",
    mortgageDataTitle: "Data untuk KPR",
    name: "Nama",
    placeHolderName: "Tulis Nama",
    phoneNumber: "Nomor Telepon",
    placeHolderPhone: "Telepon",
    monthlyIncomeRange: "Kisaran Penghasilan Bulanan",
    propertyPriceRange: "Kisaran Harga Properti",
    propertyLocation: "Lokasi Properti",
    relatedAreas: "Area Terkait",
    dataUsage: "Data digunakan agar kamu dapat rekomendasi KPR yang sesuai.",
    privacyAgreement: "Saya setuju dengan Kebijakan Privasi Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner bank.",
    continue: "Lanjut",
    phoneVerification: "Verifikasi Nomor Handphone",
    changeNumber: "Ganti Nomor",
    noOTP: "Tidak mendapatkan kode OTP?",
    resend: "Kirim Ulang",
    completePersonalData: "Lengkapi Data Diri untuk KPR",
    applyTiming: "Kapan kamu akan mengajukan KPR?",
    timingOptions: ["Segera", "1 - 3 Bulan", "3 - 6 Bulan", "> 6 Bulan"],
    desiredProperty: "Sudah ada properti yang diinginkan?",
    propertyOptions: ["Sudah", "Belum"],
    occupationType: "Tipe Pekerjaan",
    occupationOptions: [
      "Karyawan",
      "Profesional",
      "Pegawai Pemerintahan",
      "Wiraswasta",
      "Pegawai BUMN/BUMD",
      "Lainnya"
    ],
    employmentLength: "Lama Bekerja",
    maritalStatus: "Status Perkawinan",
    maritalOptions: ["Tidak Kawin", "Kawin", "Cerai hidup", "Cerai mati"],
    submit: "Ajukan",
    dataSentSuccess: "Data Berhasil Terkirim",
    dataConfirmation: "Kami akan terhubung dengan Tim Rumah123 untuk konfirmasi data",
    wrongOTP: "Kode yg Anda masukan salah pastikan kode OTP yang Anda masukan benar",
    send: "Kirim",
    searchLocation: "Sedang mencari lokasi",
    noGettingOTP: "Tidak mendapatkan Kode OTP?",
    placeHolderLocation: "Cari area atau kota",
    privacyEnsure: "Rumah123 menjaga keamanan data diri kamu",
    employmentStatus: "Status Pekerjaan",
    mortgageDataFill: "Data Lengkap KPR"
  },
  en: {
    question: "Question",
    mortgageDataTitle: "Mortgage Data",
    name: "Name",
    placeHolderName: "Your Name",
    phoneNumber: "Phone Number",
    placeHolderPhone: "Phone",
    monthlyIncomeRange: "Monthly Income",
    propertyPriceRange: "Property Price",
    propertyLocation: "Property Location",
    relatedAreas: "Related Areas",
    dataUsage: "This data is used to provide you with suitable mortgage recommendations.",
    privacyAgreement: "I agree to the Privacy Policy of Rumah123 and authorize us to share data with partner banks.",
    continue: "Continue",
    phoneVerification: "Phone Number Verification",
    changeNumber: "Change Number",
    noOTP: "Didn't receive the OTP?",
    resend: "Resend",
    completePersonalData: "Complete Personal Data for Mortgage",
    applyTiming: "When will you apply for a mortgage?",
    timingOptions: [
      "Immediately",
      "1 - 3 months",
      "3 - 6 months",
      "> 6 months"
    ],
    desiredProperty: "Do you already have a desired property?",
    propertyOptions: ["Yes", "No"],
    occupationType: "Occupation Type",
    occupationOptions: [
      "Employee",
      "Professional",
      "Government Employee",
      "Entrepreneur",
      "BUMN/BUMD Employee",
      "Other"
    ],
    employmentLength: "Duration of Employment",
    maritalStatus: "Marital Status",
    maritalOptions: [
      "Single",
      "Married",
      "Separated (living apart)",
      "Widowed"
    ],
    submit: "Submit",
    dataSentSuccess: "The data has been successfully sent",
    dataConfirmation: "You will be connected with the Rumah123 team for data confirmation",
    wrongOTP: "The code inserted does not match the expected value",
    send: "Send",
    searchLocation: "Searching for location",
    noGettingOTP: "Not getting OTP code?",
    placeHolderLocation: "Search area or city",
    privacyEnsure: "Rumah123 ensures the security of your personal data",
    employmentStatus: "Employment Status",
    mortgageDataFill: "Mortgage Data"
  }
};
var PhoneList = ({
  value,
  onChange
}) => {
  const [isShowList, setShowList] = useState(false);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("p", { className: "flex items-center gap-x-1 cursor-pointer w-max mb-0", children: [
      /* @__PURE__ */ jsx("span", { children: value }),
      /* @__PURE__ */ jsx(
        "svg",
        {
          width: "13",
          height: "8",
          viewBox: "0 0 13 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M0.455739 1.71988L5.87774 6.92488C6.07124 7.11088 6.37724 7.11088 6.57074 6.92488L11.9927 1.71988C12.1922 1.52838 12.1987 1.21138 12.0072 1.01238C11.8157 0.813379 11.4987 0.806379 11.2997 0.997879L5.87774 6.20288H6.57074L1.14874 0.997879C0.949238 0.806379 0.632738 0.812879 0.441238 1.01238C0.249738 1.21188 0.256239 1.52838 0.455739 1.71988Z",
              fill: "#0D1A35"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "select",
      {
        className: "absolute top-0 left-0 opacity-0 h-full cursor-pointer",
        onChange: (e) => {
          onChange(e.target.value);
        },
        children: phoneNumbers.map((item) => {
          return /* @__PURE__ */ jsx("option", { value: item.value, children: item.label }, `${item.value}-${item.label}`);
        })
      }
    ),
    isShowList && /* @__PURE__ */ jsx("div", { className: "absolute top-full bg-white rounded-lg shadow-lg -left-3 overflow-auto max-h-36 no-scrollbar", children: /* @__PURE__ */ jsx("ul", { className: "list-none", children: phoneNumbers.map((item) => {
      return /* @__PURE__ */ jsx(
        "li",
        {
          className: "w-full whitespace-nowrap p-2 cursor-pointer hover:bg-[#F4F4F6]",
          onClick: () => {
            onChange(item.value);
            setShowList(false);
          },
          children: item.label
        },
        `${item.value}-${item.label}`
      );
    }) }) })
  ] });
};
var PhoneInputList_default = PhoneList;
var IconCheck = ({ checked = false }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_361_10296)", children: [
          /* @__PURE__ */ jsxs(
            "mask",
            {
              id: "mask0_361_10296",
              style: {
                maskType: "luminance"
              },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "16",
              height: "16",
              children: [
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M7.99968 14.6663C8.87532 14.6675 9.74256 14.4956 10.5515 14.1605C11.3605 13.8253 12.0953 13.3337 12.7137 12.7137C13.3337 12.0953 13.8253 11.3605 14.1605 10.5515C14.4956 9.74256 14.6675 8.87532 14.6663 7.99968C14.6675 7.12404 14.4955 6.25681 14.1604 5.44782C13.8253 4.63884 13.3337 3.90405 12.7137 3.28568C12.0953 2.66569 11.3605 2.17401 10.5515 1.83891C9.74256 1.5038 8.87532 1.33188 7.99968 1.33301C7.12404 1.3319 6.25681 1.50383 5.44782 1.83893C4.63884 2.17404 3.90405 2.6657 3.28568 3.28568C2.6657 3.90405 2.17404 4.63884 1.83893 5.44782C1.50383 6.25681 1.3319 7.12404 1.33301 7.99968C1.33188 8.87532 1.5038 9.74256 1.83891 10.5515C2.17401 11.3605 2.66569 12.0953 3.28568 12.7137C3.90405 13.3337 4.63884 13.8253 5.44782 14.1604C6.25681 14.4955 7.12404 14.6675 7.99968 14.6663Z",
                    fill: "white",
                    stroke: "white",
                    strokeLinejoin: "round"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M5.33301 8L7.33301 10L11.333 6",
                    stroke: "black",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_361_10296)", children: /* @__PURE__ */ jsx("path", { d: "M0 0H16V16H0V0Z", fill: checked ? "#38BAA7" : "#CFD1D7" }) })
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_361_10296", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
};
var IconCheck_default = IconCheck;
var LoaderFull = ({ className }) => {
  return /* @__PURE__ */ jsxs("div", { className: tailwindHelpers.cn(className), children: [
    /* @__PURE__ */ jsx("div", { className: "absolute inset-0 rounded-2xl bg-[rgba(255,255,255,0.80)] blur-lg z-[2]" }),
    /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex justify-center items-center z-[3]", children: /* @__PURE__ */ jsx(
      "img",
      {
        width: 80,
        height: 80,
        src: "https://www.rumah123.com/asset-core/images/agent/loading-blue.gif"
      }
    ) })
  ] });
};
var LoaderFull_default = LoaderFull;
var ModalBaseData = ({
  buttonText,
  title,
  language = "id",
  children,
  onSubmit,
  isModalBaseBasic,
  name,
  email,
  phoneNumber,
  updateForm,
  disabled,
  isLoading,
  initPrefix,
  contentClassName,
  childrenBeforeForm,
  showChecked = false,
  showLoaderFull = false,
  className,
  ...props
}) => {
  const [prefixPhoneNumber, setPrefixPhoneNumber] = useState(
    initPrefix || "+62"
  );
  const onSubmitForm = () => {
    if (!onSubmit)
      return;
    onSubmit({
      prefixPhoneNumber
    });
  };
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: tailwindHelpers.cn(
        "md:w-[420px]",
        {
          "overflow-y-hidden p-0": showLoaderFull && isLoading
        },
        className
      ),
      contentClassName: tailwindHelpers.cn({
        "overflow-y-hidden relative p-4 max-h-[calc(100vh-1rem)]": showLoaderFull && isLoading
      }),
      title: title || TRANSLATION[language].mortgageDataTitle,
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "form",
          {
            className: tailwindHelpers.cn(
              "flex flex-col gap-y-4",
              contentClassName
            ),
            children: [
              childrenBeforeForm,
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(Label, { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsxs("div", { children: [
                    TRANSLATION[language].name,
                    " ",
                    /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                  ] }),
                  showChecked && /* @__PURE__ */ jsx(IconCheck_default, { checked: !!name })
                ] }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    placeholder: TRANSLATION[language].placeHolderName,
                    type: "text",
                    className: "text-base !px-4",
                    required: true,
                    value: name,
                    onChange: (e) => {
                      updateForm({
                        name: e.target.value
                      });
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(Label, { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsxs("div", { children: [
                    TRANSLATION[language].phoneNumber,
                    " ",
                    /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                  ] }),
                  showChecked && /* @__PURE__ */ jsx(IconCheck_default, { checked: !!phoneNumber })
                ] }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    placeholder: TRANSLATION[language].placeHolderPhone,
                    type: "text",
                    className: "text-base !px-4 relative",
                    containerClassName: "relative",
                    required: true,
                    prefix: /* @__PURE__ */ jsx(
                      PhoneInputList_default,
                      {
                        value: prefixPhoneNumber,
                        onChange: (value) => {
                          setPrefixPhoneNumber(value);
                        }
                      }
                    ),
                    value: phoneNumber,
                    onChange: (e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      const numericValue = rawValue ?? "";
                      updateForm({
                        phoneNumber: numericValue
                      });
                    }
                  }
                )
              ] }),
              children
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              onSubmitForm();
            },
            type: "button",
            disabled: disabled || isLoading,
            className: "h-12 flex justify-center items-center bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-6 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: isLoading && !showLoaderFull ? /* @__PURE__ */ jsx(Loader_default, {}) : buttonText || TRANSLATION[language].continue
          }
        ),
        isLoading && showLoaderFull && /* @__PURE__ */ jsx(LoaderFull_default, {})
      ]
    }
  );
};

// src/helper/index.ts
var formatNumber = (value, symbol) => {
  if (!value)
    return "";
  const numberParam = !Number.isNaN(value) ? value : 0;
  const number = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
  return number.formatToParts(Math.round(numberParam)).filter((p) => p.type !== "currency").reduce((s, p) => s + p.value, "").trim();
};
var constructUrl = ({ baseUrl, pathname, key }) => {
  try {
    const url = new URL(
      `${baseUrl ? baseUrl : window.location.origin}${pathname}`
    );
    if (key) {
      url.searchParams.set("key", key);
    }
    return url.toString();
  } catch (err) {
    return "/";
  }
};

// src/ModalBaseData/helper.ts
var cleanPrefixFromPhoneNumber = (prefix, phoneNumber) => {
  const phoneNumberWithoutZero = phoneNumber.startsWith("0") ? phoneNumber.slice(1) : phoneNumber;
  const cleanPrefix = prefix.startsWith("+") ? prefix.slice(1) : prefix;
  const cleanPhoneNumber = phoneNumberWithoutZero.startsWith("+") ? phoneNumberWithoutZero.slice(1) : phoneNumberWithoutZero;
  const hasPrefix = cleanPhoneNumber.startsWith(cleanPrefix);
  const processedNumber = hasPrefix ? cleanPhoneNumber.slice(cleanPrefix.length) : cleanPhoneNumber;
  return processedNumber;
};
var ModalTakeOver = ({
  onSubmit,
  initForm,
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", phoneNumber: "", salary: 0 });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const [isAggreTnc, setAggressTnc] = useState(true);
  return /* @__PURE__ */ jsxs(
    ModalBaseData,
    {
      updateForm: (data) => {
        updateForm(data);
      },
      ...formData,
      ...props,
      onSubmit: (value) => {
        const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
          value.prefixPhoneNumber,
          formData.phoneNumber || ""
        );
        onSubmit({
          ...value,
          ...formData,
          phoneNumber: `${value.prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
          salary: formData.salary || 0
        });
      },
      disabled: !isAggreTnc || !formData.salary,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxs(Label, { children: [
            "Kisaran Penghasilan Bulanan ",
            /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
          ] }),
          /* @__PURE__ */ jsx(
            Input,
            {
              placeholder: "0",
              type: "text",
              className: "text-base !px-4",
              prefix: "Rp",
              value: formData.salary ? formatNumber(+formData.salary) : "",
              onChange: (e) => {
                const rawValue = e.target.value.replace(/\D/g, "");
                const numericValue = rawValue ? +rawValue : 0;
                if (numericValue > 1e12)
                  return;
                updateForm({
                  salary: numericValue
                });
              }
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "text-accent font-medium text-xs", children: "Jika sudah menikah bisa masukkan penghasilan istri/suami/gabungan keduanya" }),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: tailwindHelpers.cn(
                "mt-1 hidden text-xs font-medium text-errorAlert",
                {
                  "group-invalid/form:block": !formData.salary
                }
              ),
              children: "Penghasilan wajib diisi"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            name: "mortgage-tnc",
            onChange: (value) => {
              setAggressTnc(value.length > 0);
            },
            value: isAggreTnc ? ["mortgage-tnc"] : [],
            children: /* @__PURE__ */ jsx(
              CheckboxItem,
              {
                id: "mortgage-tnc",
                label: /* @__PURE__ */ jsxs("span", { className: "text-greyText font-medium text-xs", children: [
                  "Saya setuju dengan",
                  " ",
                  /* @__PURE__ */ jsx(
                    "a",
                    {
                      className: "text-primary30 no-underline",
                      title: "Kebijakan Privasi",
                      href: "/kebijakan-privasi/",
                      target: "_blank",
                      children: "Kebijakan Privasi"
                    }
                  ),
                  " ",
                  "Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner bank."
                ] }),
                value: "mortgage-tnc"
              }
            )
          }
        ) })
      ]
    }
  );
};
var ModalTakeOver_default = ModalTakeOver;
var ModalBasic = ({
  buttonText = "Kirim",
  title = "Lihat Detail",
  children,
  initForm,
  onSubmit,
  language = "id",
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", phoneNumber: "" });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber
    });
  };
  const getDisabledButton = () => {
    return !formData.name || !formData.phoneNumber;
  };
  return /* @__PURE__ */ jsx(
    ModalBaseData,
    {
      language,
      disabled: getDisabledButton(),
      className: "md:w-[375px] p-4",
      title,
      updateForm,
      showLoaderFull: true,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      contentClassName: "gap-y-5",
      buttonText,
      name: formData.name,
      phoneNumber: formData.phoneNumber
    }
  );
};

// src/ModalDetailData/constant.ts
var ETA = [
  { id: "Segera", en: "Immediately", value: "Segera" },
  { id: "1 - 3 Bulan", en: "1 - 3 months", value: "1 - 3 Bulan" },
  { id: "3 - 6 Bulan", en: "3 - 6 months", value: "3 - 6 Bulan" },
  { id: "> 6 Bulan", en: "> 6 months", value: "> 6 Bulan" }
];
var HAS_DESIRED_PROPERTY = [
  { id: "Sudah", en: "Yes", value: "Sudah" },
  { id: "Belum", en: "No", value: "Belum" }
];
var JOB_TYPE = [
  { id: "Karyawan", en: "Employee", value: "Karyawan" },
  { id: "Profesional", en: "Professional", value: "Profesional" },
  { id: "Wiraswasta", en: "Entrepreneur", value: "Wiraswasta" },
  {
    id: "Pegawai BUMN/BUMD",
    en: "State-Owned Enterprise Employee",
    value: "Pegawai BUMN/BUMD"
  },
  {
    id: "ASN",
    en: "Civil Servant",
    value: "ASN"
  },
  { id: "Lainnya", en: "Other", value: "Lainnya" }
];
var JOB_STATUS = [
  { id: "Tetap", en: "Permanent", value: "Tetap" },
  { id: "Kontrak", en: "Contract", value: "Kontrak" },
  { id: "Freelance", en: "Freelance", value: "Freelance" },
  { id: "Lainnya", en: "Others", value: "Lainnya" }
];
var MARRIAGE_STATUS = [
  { id: "Tidak Kawin", en: "Single", value: "Tidak Kawin" },
  { id: "Kawin", en: "Married", value: "Kawin" },
  { id: "Cerai hidup", en: "Separated (living apart)", value: "Cerai hidup" },
  { id: "Cerai mati", en: "Widowed", value: "Cerai mati" }
];
var ModalEntryPoint = ({
  buttonText = "Lanjut",
  title = "Data untuk KPR",
  children,
  initForm,
  onSubmit,
  language = "id",
  ...props
}) => {
  const [formData, setFormData] = useState(
    {
      ...initForm,
      eta: initForm?.desiredProperty === "Sudah" ? "" : initForm?.eta
    }
  );
  const [isAggreTnc, setAggressTnc] = useState(true);
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber,
      isLowIntent: formData.desiredProperty === "Belum" && formData.eta === "> 6 Bulan"
    });
  };
  const getDisabledButton = () => {
    const isBaseInvalid = !formData.name || !formData.phoneNumber || !isAggreTnc;
    if (formData.desiredProperty === "Belum") {
      return isBaseInvalid || !formData.eta;
    }
    return isBaseInvalid || !formData.desiredProperty;
  };
  return /* @__PURE__ */ jsxs(
    ModalBaseData,
    {
      disabled: getDisabledButton(),
      className: "md:w-[375px] p-4",
      title,
      updateForm,
      showChecked: true,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      name: formData.name,
      phoneNumber: formData.phoneNumber,
      showLoaderFull: true,
      language,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.desiredProperty, children: [
            TRANSLATION[language].desiredProperty,
            " ",
            /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: HAS_DESIRED_PROPERTY.map((item) => {
            const isActive = formData.desiredProperty === item.value;
            return /* @__PURE__ */ jsx(
              ChipSelection,
              {
                isActive,
                onClick: () => {
                  if (isActive)
                    return;
                  updateForm({
                    desiredProperty: item.value,
                    eta: item.value === "Sudah" ? "" : formData.eta
                  });
                },
                children: item[language]
              },
              item.value
            );
          }) })
        ] }),
        formData.desiredProperty === "Belum" && /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.eta, children: [
            TRANSLATION[language].applyTiming,
            " ",
            /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: ETA.map((item) => {
            const isActive = formData.eta === item.value;
            return /* @__PURE__ */ jsx(
              ChipSelection,
              {
                isActive,
                onClick: () => {
                  if (isActive)
                    return;
                  updateForm({ eta: item.value });
                },
                children: item[language]
              },
              item.value
            );
          }) })
        ] }),
        /* @__PURE__ */ jsx("hr", { className: "border-none bg-greyBorder w-full h-[0.5px]" }),
        /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            name: "mortgage-tnc",
            onChange: (value) => {
              setAggressTnc(value.length > 0);
            },
            value: isAggreTnc ? ["mortgage-tnc"] : [],
            children: /* @__PURE__ */ jsx(
              CheckboxItem,
              {
                id: "mortgage-tnc",
                label: /* @__PURE__ */ jsx(Fragment, { children: language === "id" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("span", { className: "text-greyText text-xs", children: [
                  "Saya setuju dengan",
                  " ",
                  /* @__PURE__ */ jsx(
                    "a",
                    {
                      className: "text-primary30 no-underline",
                      title: "Kebijakan Privasi",
                      href: "/kebijakan-privasi/",
                      target: "_blank",
                      children: "Kebijakan Privasi"
                    }
                  ),
                  " ",
                  "Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner bank."
                ] }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("span", { className: "text-greyText text-xs", children: [
                  "I agree with Rumah123",
                  " ",
                  /* @__PURE__ */ jsx(
                    "a",
                    {
                      className: "text-primary30 no-underline",
                      title: "Privacy Policy",
                      href: "/en/privacy-policy/",
                      target: "_blank",
                      children: "Privacy Policy"
                    }
                  ),
                  " ",
                  "and authorize them to forward data to partner banks."
                ] }) }) }),
                value: "mortgage-tnc"
              }
            )
          }
        ) })
      ]
    }
  );
};
var Icon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "42",
      height: "46",
      viewBox: "0 0 42 46",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "shrink-0",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.0013 39.9994C31.617 39.9994 40.2228 31.3936 40.2228 20.7778C40.2228 10.1621 31.617 1.55627 21.0013 1.55627C10.3855 1.55627 1.77969 10.1621 1.77969 20.7778C1.77969 31.3936 10.3855 39.9994 21.0013 39.9994Z",
            fill: "#C4D4EC"
          }
        ),
        /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_dd_361_7467)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M6.77749 37.5146L4.16938 18.5302C4.07224 17.8231 4.51152 17.1527 5.19859 16.9595C5.29121 16.9335 5.38622 16.9168 5.48217 16.9099L26.207 15.4064C26.5062 15.3847 26.8064 15.4309 27.0853 15.5415C29.0035 16.3025 28.6398 19.12 26.5913 19.369L15.1742 20.7565C14.8949 20.7904 14.6325 20.9082 14.4215 21.0943C14.1719 21.3146 14.011 21.6159 13.9588 21.9447C13.0133 27.907 9.40728 38.5961 9.01726 38.9536C8.76736 39.1826 8.37485 39.1859 8.03345 39.1187C7.68136 39.0495 7.40396 38.7982 7.19904 38.5036L7.11827 38.3875C6.93738 38.1275 6.8206 37.8284 6.77749 37.5146Z",
              fill: "#E89A26"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "19.1734",
              height: "27.7611",
              rx: "2.67584",
              transform: "matrix(-0.991605 -0.129307 -0.129322 0.991603 35.8426 7.40247)",
              fill: "#EAE9F6"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "7.44198",
              rx: "1.33792",
              transform: "matrix(-0.991605 -0.129307 -0.129322 0.991603 33.3958 9.99939)",
              fill: "#6FACA8"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(-0.991605 -0.129307 -0.129322 0.991603 32.2928 18.4542)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(-0.991605 -0.129307 -0.129322 0.991603 31.9792 20.8624)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(-0.991605 -0.129307 -0.129322 0.991603 31.6657 23.2638)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M26.787 6.21319L21.4352 5.58606L22.3968 26.5741L29.4211 25.4034L26.787 6.21319Z",
              fill: "black",
              fillOpacity: "0.1"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "19.1734",
              height: "24.5836",
              rx: "2.67584",
              transform: "matrix(0.991605 -0.129307 0.129322 0.991603 5.54706 6.47961)",
              fill: "#EAE9F6"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "7.44198",
              rx: "1.33792",
              transform: "matrix(0.991605 -0.129307 0.129322 0.991603 7.9939 9.078)",
              fill: "#86C7C3"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(0.991605 -0.129307 0.129322 0.991603 9.0968 17.5336)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(0.991605 -0.129307 0.129322 0.991603 9.41046 19.9396)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: "14.8848",
              height: "1.33788",
              rx: "0.668942",
              transform: "matrix(0.991605 -0.129307 0.129322 0.991603 9.72394 22.3419)",
              fill: "#97A2DA"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M14.4256 19.6832L36.6545 17.8831C37.1945 17.8394 37.5051 18.1462 37.6616 18.4481C37.7762 18.6691 37.758 18.9253 37.7074 19.1691C36.6534 24.2487 34.6711 33.9892 34.6058 35.0665C34.5389 36.1703 32.9891 36.8643 32.2225 37.0733L11.8762 39.9798C11.7822 39.9932 11.6874 39.9999 11.5924 39.9999H9.82626C9.48758 39.9999 9.15409 39.915 8.85927 39.7483C8.19242 39.3713 7.425 38.9158 7.72114 38.9965C7.90271 39.046 8.20036 38.9686 8.50053 38.8507C9.03487 38.6408 9.37219 38.1304 9.48089 37.5667L12.617 21.3035C12.7877 20.4186 13.5273 19.756 14.4256 19.6832Z",
              fill: "#F6C52F"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M14.4256 19.6832L36.6545 17.8831C37.1945 17.8394 37.5051 18.1462 37.6616 18.4481C37.7762 18.6691 37.758 18.9253 37.7074 19.1691C36.6534 24.2487 34.6711 33.9892 34.6058 35.0665C34.5389 36.1703 32.9891 36.8643 32.2225 37.0733L11.8762 39.9798C11.7822 39.9932 11.6874 39.9999 11.5924 39.9999H9.82626C9.48758 39.9999 9.15409 39.915 8.85927 39.7483C8.19242 39.3713 7.425 38.9158 7.72114 38.9965C7.90271 39.046 8.20036 38.9686 8.50053 38.8507C9.03487 38.6408 9.37219 38.1304 9.48089 37.5667L12.617 21.3035C12.7877 20.4186 13.5273 19.756 14.4256 19.6832Z",
              fill: "#F8D179"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "filter0_dd_361_7467",
            x: "0.759742",
            y: "2.62549",
            width: "40.3834",
            height: "42.4689",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: "1.69812" }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "1.69812" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_361_7467"
                }
              ),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", {}),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.424529" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "effect1_dropShadow_361_7467",
                  result: "effect2_dropShadow_361_7467"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect2_dropShadow_361_7467",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
var HeaderForm = ({
  firstName,
  step,
  language
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "rounded-2xl text-white flex items-center gap-x-2 p-4",
      style: {
        background: "linear-gradient(101deg, #2951A3 51.83%, #4676D9 89.87%, #C1D1F2 105.58%, #FFF 123.71%), linear-gradient(0deg, #0F3175 0%, #0F3175 100%), #0F3175"
      },
      children: [
        /* @__PURE__ */ jsx(Icon, {}),
        /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-3 justify-between", children: [
            /* @__PURE__ */ jsxs("p", { className: "font-bold mb-0", children: [
              "Hi ",
              firstName
            ] }),
            /* @__PURE__ */ jsxs("p", { className: "font-bold mb-0", children: [
              step,
              "/2 ",
              /* @__PURE__ */ jsx("span", { className: "text-xs", children: "Form" })
            ] })
          ] }),
          /* @__PURE__ */ jsx("p", { className: "mb-0 font-light text-xs", children: TRANSLATION[language].completePersonalData })
        ] })
      ]
    }
  );
};
var HeaderForm_default = HeaderForm;
var ChipSelection2 = ({
  className,
  isActive,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "button",
      className: tailwindHelpers.cn(
        "py-1 px-2 border border-solid font-light text-sm cursor-pointer rounded-lg",
        {
          "bg-blueBase text-white border-transparent": isActive,
          "bg-white border-greyText text-greyText": !isActive
        },
        className
      ),
      ...props
    }
  );
};

// src/api.ts
var requestOtp = async ({
  url,
  payload,
  key
}) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const raw = JSON.stringify(payload);
  const requestOptions = {
    method: "POST",
    headers,
    body: raw
  };
  return fetch(url, requestOptions).then((response) => response.json()).then((result) => {
    return {
      success: true,
      result
    };
  }).catch((error) => {
    return {
      success: false,
      error
    };
  });
};
var verifyOtp = async ({
  url,
  payload
}) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const raw = JSON.stringify(payload);
  const requestOptions = {
    method: "POST",
    headers,
    body: raw
  };
  return fetch(url, requestOptions).then((response) => response.json()).then((result) => {
    return {
      success: true,
      result
    };
  }).catch((error) => {
    return {
      success: false,
      error
    };
  });
};
var fetchLocationSuggestion = async ({
  url,
  query
}) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const raw = JSON.stringify({
    kinds: "LOCATION" /* Location */,
    portalId: 1,
    query,
    subChannel: "SUB_SALE",
    locationTypes: ["CITY", "DISTRICT"]
  });
  const requestOptions = {
    method: "POST",
    headers,
    body: raw
  };
  return fetch(url, requestOptions).then((response) => response.json()).then((result) => {
    return {
      success: true,
      result
    };
  }).catch((error) => {
    return {
      success: false,
      error
    };
  });
};
var mortgageEnquiryMutation = async ({
  url,
  payload
}) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const raw = JSON.stringify(payload);
  const requestOptions = {
    method: "POST",
    headers,
    body: raw
  };
  return fetch(url, requestOptions).then((response) => response.json()).then((result) => {
    return {
      success: true,
      result
    };
  }).catch((error) => {
    return {
      success: false,
      error
    };
  });
};

// src/ModalDetailData/useLocationSuggestion.tsx
var useLocationSuggestion = ({
  locationUrl,
  onFetchLocationSuggestion
}) => {
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [suggestion, setSuggestion] = useState(
    []
  );
  useOnClickOutside(wrapperRef, () => {
    setIsOpen(false);
  });
  const handleOnChange = (
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(
      debounce(async (keyword) => {
        fetchSuggestions(keyword);
      }, 1e3),
      []
    )
  );
  const fetchSuggestions = async (keyword) => {
    if (keyword.length === 0) {
      setIsOpen(false);
    }
    if (keyword.length > 3) {
      setIsLoading(true);
      try {
        if (onFetchLocationSuggestion) {
          const data = await onFetchLocationSuggestion({
            query: keyword
          });
          setSuggestion(data || []);
          setIsOpen(true);
          return;
        }
        const url = locationUrl ? constructUrl(locationUrl) : "/";
        const locationResult = await fetchLocationSuggestion({
          url,
          query: keyword
        });
        setSuggestion(locationResult?.result?.data || []);
        setIsOpen(true);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    }
  };
  return {
    action: {
      handleOnChange,
      setIsOpen,
      setSuggestion
    },
    data: { isOpen, suggestion, isLoading },
    ref: { wrapperRef, inputRef }
  };
};
var useLocationSuggestion_default = useLocationSuggestion;

// src/ModalDetailData/helper.ts
var renderLabelWithSearch = (text, searchText) => {
  if (!text || !searchText)
    return text;
  const textLower = text.toLowerCase();
  const searchTextLower = searchText.toLowerCase();
  if (textLower.indexOf(searchTextLower) !== -1 && searchText.length > 0) {
    let textTemp = "";
    textTemp = text.substring(0, textLower.indexOf(searchTextLower));
    textTemp += "<c class='text-primary'>";
    textTemp += text.substring(
      textLower.indexOf(searchTextLower),
      textLower.indexOf(searchTextLower) + searchText.length
    );
    textTemp += "</c>";
    textTemp += text.substring(
      textLower.indexOf(searchTextLower) + searchText.length
    );
    return textTemp;
  } else {
    return text;
  }
};
var categoryLabel = (lang, label) => {
  switch (label) {
    case 9:
      return "Area";
    case 8:
      return lang === "id" ? "Kota" : "City";
    case 7:
      return lang === "id" ? "Provinsi" : "Province";
    case "APARTMENT_VENUE" /* ApartmentVenue */:
      return lang === "id" ? "Apartemen" : "Apartment";
    case "VENUE" /* Venue */:
      return lang === "id" ? "Komplek" : "Venue";
    case "PROPERTY" /* Property */:
      return lang === "id" ? "Properti" : "Property";
    default:
      return "";
  }
};
var LocationSuggestion = ({
  value,
  onChange,
  locationUrl,
  language = "id",
  onFetchLocationSuggestion
}) => {
  const {
    ref: { inputRef, wrapperRef },
    data: { suggestion, isOpen, isLoading },
    action: { handleOnChange, setSuggestion, setIsOpen }
  } = useLocationSuggestion_default({ locationUrl, onFetchLocationSuggestion });
  useEffect(() => {
    if (value === inputRef.current?.value)
      return;
    if (!inputRef.current)
      return;
    inputRef.current.value = value || "";
  }, [value]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: wrapperRef,
      className: "relative z-1 bg-white rounded-md border border-solid border-lightGray px-4 flex item-center gap-x-2",
      children: [
        /* @__PURE__ */ jsx("span", { className: "shrink-0 flex", children: /* @__PURE__ */ jsx(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "h-full",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.2709 15.4394C13.1255 15.4394 15.4396 13.1253 15.4396 10.2708C15.4396 7.41635 13.1255 5.10228 10.2709 5.10228C7.4164 5.10228 5.10229 7.41635 5.10229 10.2708C5.10229 13.1247 7.4164 15.4394 10.2709 15.4394ZM10.2709 4C13.7343 4 16.5419 6.80748 16.5419 10.2708C16.5419 11.804 15.9915 13.2088 15.0776 14.2983L19.8386 19.0593C20.0541 19.2742 20.0535 19.623 19.8386 19.8384C19.6238 20.0539 19.275 20.0539 19.0595 19.8384L14.2985 15.0774C13.209 15.9913 11.8042 16.5417 10.2709 16.5417C6.80752 16.5417 4 13.7336 4 10.2708C4 6.80748 6.80752 4 10.2709 4Z",
                fill: "#677E8C"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: inputRef,
            className: tailwindHelpers.cn(
              "py-2 w-full outline-none border-none leading-6 text-accent placeholder:text-disabledText"
            ),
            placeholder: TRANSLATION[language].placeHolderLocation,
            onChange: (e) => {
              setSuggestion([]);
              handleOnChange(e.target.value);
            },
            onFocus: () => {
              if (inputRef.current && inputRef.current.value.length > 3) {
                setIsOpen(true);
              }
            }
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: tailwindHelpers.cn(
              "p-4 bg-white rounded-lg shadow-lg absolute top-full gap-y-2 flex flex-col items-center text-center left-0 w-full",
              { hidden: !isLoading }
            ),
            children: [
              /* @__PURE__ */ jsxs(
                "svg",
                {
                  width: "25",
                  height: "24",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "animate-spin",
                  children: [
                    /* @__PURE__ */ jsx(
                      "path",
                      {
                        opacity: "0.5",
                        d: "M12.5 2C10.5222 2 8.58879 2.58649 6.9443 3.6853C5.29981 4.78412 4.01809 6.3459 3.26121 8.17317C2.50433 10.0004 2.3063 12.0111 2.69215 13.9509C3.078 15.8907 4.03041 17.6725 5.42894 19.0711C6.82746 20.4696 8.60929 21.422 10.5491 21.8079C12.4889 22.1937 14.4996 21.9957 16.3268 21.2388C18.1541 20.4819 19.7159 19.2002 20.8147 17.5557C21.9135 15.9112 22.5 13.9778 22.5 12C22.5 10.6868 22.2413 9.38642 21.7388 8.17317C21.2363 6.95991 20.4997 5.85752 19.5711 4.92893C18.6425 4.00035 17.5401 3.26375 16.3268 2.7612C15.1136 2.25866 13.8132 2 12.5 2ZM12.5 20C10.9178 20 9.37104 19.5308 8.05544 18.6518C6.73985 17.7727 5.71447 16.5233 5.10897 15.0615C4.50347 13.5997 4.34504 11.9911 4.65372 10.4393C4.9624 8.88743 5.72433 7.46197 6.84315 6.34315C7.96197 5.22433 9.38743 4.4624 10.9393 4.15372C12.4911 3.84504 14.0997 4.00346 15.5615 4.60896C17.0233 5.21447 18.2727 6.23984 19.1518 7.55544C20.0308 8.87103 20.5 10.4177 20.5 12C20.5 14.1217 19.6572 16.1566 18.1569 17.6569C16.6566 19.1571 14.6217 20 12.5 20Z",
                        fill: "#B6BAC2"
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "path",
                      {
                        d: "M20.5 12H22.5C22.5 10.6868 22.2413 9.38642 21.7388 8.17317C21.2362 6.95991 20.4997 5.85752 19.5711 4.92893C18.6425 4.00035 17.5401 3.26375 16.3268 2.7612C15.1136 2.25866 13.8132 2 12.5 2V4C14.6217 4 16.6566 4.84285 18.1569 6.34315C19.6571 7.84344 20.5 9.87827 20.5 12Z",
                        fill: "#B6BAC2"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs("p", { className: "text-center text-xs text-greyText", children: [
                TRANSLATION[language].searchLocation,
                "..."
              ] })
            ]
          }
        ),
        !isLoading && isOpen && suggestion && suggestion.length > 0 && /* @__PURE__ */ jsxs("div", { className: "absolute top-full rounded-lg overflow-hidden left-0 w-full z-1 bg-white shadow-lg", children: [
          /* @__PURE__ */ jsx("p", { className: "p-4 bg-lightBlue font-medium text-xs m-0", children: TRANSLATION[language].relatedAreas }),
          /* @__PURE__ */ jsx("ul", { className: "max-h-52 no-scrollbar overflow-y-auto", children: suggestion.map((item) => {
            return /* @__PURE__ */ jsxs(
              "li",
              {
                className: "cursor-pointer p-4 flex items-center gap-x-2 border-0 border-b border-solid border-secondaryHover",
                onClick: () => {
                  onChange({
                    province: item.province,
                    city: item.city,
                    district: item.district,
                    kind: item.kind,
                    label: item.label,
                    portalId: 0,
                    subTitle: item.subTitle,
                    title: item.title,
                    uuid: item.uuid
                  });
                  setIsOpen(false);
                },
                children: [
                  /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                    /* @__PURE__ */ jsx(
                      "p",
                      {
                        className: "font-medium",
                        dangerouslySetInnerHTML: {
                          __html: renderLabelWithSearch(
                            item.title,
                            inputRef.current?.value || ""
                          )
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx("p", { className: "text-[#868D9A] text-xs mb-0 mt-0.5", children: item.subTitle })
                  ] }),
                  item?.kind !== "DEVELOPER" /* Developer */ && item?.kind !== "PROPERTY" /* Property */ && /* @__PURE__ */ jsx("span", { className: "text-xs text-slate-500 font-normal py-1 px-2 rounded-full bg-slate-200", children: categoryLabel(language, item.locationType) })
                ]
              },
              item.uuid
            );
          }) })
        ] })
      ]
    }
  );
};
var PrivacyInfo = ({ className, language = "id" }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: tailwindHelpers.cn(
        "flex items-center gap-x-2 text-primary text-xs justify-center",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(
          "svg",
          {
            width: "21",
            height: "20",
            viewBox: "0 0 21 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M10.5 0.833008L3 4.16634V9.16634C3 13.7913 6.2 18.1163 10.5 19.1663C14.8 18.1163 18 13.7913 18 9.16634V4.16634L10.5 0.833008ZM10.5 2.64967L16.3333 5.24967V9.34968C16.3333 10.7663 15.9167 12.208 15.2083 13.4747C13.8333 12.4497 11.55 12.083 10.5 12.083C9.45 12.083 7.16667 12.4497 5.79167 13.4747C5.08333 12.208 4.66667 10.7663 4.66667 9.34968V5.24967L10.5 2.64967ZM10.5 4.99967C9.72645 4.99967 8.98459 5.30697 8.43761 5.85395C7.89062 6.40093 7.58333 7.14279 7.58333 7.91634C7.58333 8.68989 7.89062 9.43176 8.43761 9.97874C8.98459 10.5257 9.72645 10.833 10.5 10.833C11.2735 10.833 12.0154 10.5257 12.5624 9.97874C13.1094 9.43176 13.4167 8.68989 13.4167 7.91634C13.4167 7.14279 13.1094 6.40093 12.5624 5.85395C12.0154 5.30697 11.2735 4.99967 10.5 4.99967ZM10.5 6.66634C10.8315 6.66634 11.1495 6.79804 11.3839 7.03246C11.6183 7.26688 11.75 7.58482 11.75 7.91634C11.75 8.24786 11.6183 8.5658 11.3839 8.80023C11.1495 9.03465 10.8315 9.16634 10.5 9.16634C10.1685 9.16634 9.85054 9.03465 9.61612 8.80023C9.3817 8.5658 9.25 8.24786 9.25 7.91634C9.25 7.58482 9.3817 7.26688 9.61612 7.03246C9.85054 6.79804 10.1685 6.66634 10.5 6.66634ZM10.5 13.7497C11.8083 13.7497 13.5333 14.258 14.275 14.8663C13.2417 16.1497 11.9167 17.1247 10.5 17.4997C9.08333 17.1247 7.75833 16.1497 6.725 14.8663C7.475 14.258 9.19167 13.7497 10.5 13.7497Z",
                fill: "#2951A3"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx("span", { children: TRANSLATION[language].privacyEnsure })
      ]
    }
  );
};
var PrivacyInfo_default = PrivacyInfo;
var ModalFormStepOne = ({
  buttonText,
  title,
  language = "id",
  children,
  onSubmit,
  onFetchLocationSuggestion,
  isLoading,
  firstName,
  initForm,
  locationUrl,
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { desiredProperty: "Sudah", eta: "" });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = () => {
    if (!onSubmit)
      return;
    onSubmit({
      desiredProperty: formData.desiredProperty || "",
      eta: formData.eta || "",
      location: {
        province: formData.location?.province,
        city: formData.location?.city,
        district: formData.location?.district,
        title: formData.location?.title,
        uuid: formData.location?.uuid
      },
      propertyPrice: formData.propertyPrice || 0
    });
  };
  const getDisabledButton = () => {
    const isLocationSelected = Boolean(
      formData.location?.province || formData.location?.city || formData.location?.district
    );
    return !isLocationSelected || !formData.propertyPrice || !formData.eta || !formData.desiredProperty;
  };
  const disabled = getDisabledButton();
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: tailwindHelpers.cn("md:w-[375px] p-4", {
        "overflow-y-hidden p-0": isLoading
      }),
      contentClassName: tailwindHelpers.cn({
        "overflow-y-hidden relative p-4 max-h-[calc(100vh-1rem)]": isLoading
      }),
      title: title || TRANSLATION[language].mortgageDataFill,
      ...props,
      children: [
        /* @__PURE__ */ jsx(HeaderForm_default, { firstName, step: 1, language }),
        /* @__PURE__ */ jsxs("form", { className: "flex flex-col gap-y-4 mt-6", children: [
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(Label, { children: [
              TRANSLATION[language].desiredProperty,
              " "
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex gap-1 bg-[#F0F6FF] p-1 rounded-lg flex-nowrap", children: HAS_DESIRED_PROPERTY.map((item) => {
              const isActive = formData.desiredProperty === item.value;
              return /* @__PURE__ */ jsxs(
                ChipSelection2,
                {
                  isActive,
                  className: tailwindHelpers.cn(
                    "w-full text-[#1A2258] transition-all bg-transparent border-none py-1 px-3 text-center flex items-center justify-center leading-6",
                    {
                      "text-primary font-bold bg-white gap-x-2 shadow-[0px_0px_1px_0px_rgba(40,41,61,0.04),0px_2px_4px_0px_rgba(96,97,112,0.16)]": isActive
                    }
                  ),
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({
                      desiredProperty: item.value
                    });
                  },
                  children: [
                    isActive && /* @__PURE__ */ jsx(
                      "svg",
                      {
                        width: "13",
                        height: "10",
                        viewBox: "0 0 13 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /* @__PURE__ */ jsx(
                          "path",
                          {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.28626 9.2254L1.01642 5.85447C0.661195 5.48827 0.661195 4.89672 1.01642 4.53052C1.37164 4.16431 1.94545 4.16431 2.30067 4.53052L4.93295 7.23477L11.1994 0.774605C11.5546 0.408404 12.1284 0.408404 12.4837 0.774605C12.8389 1.14081 12.8389 1.73236 12.4837 2.09856L5.57052 9.2254C5.22441 9.59161 4.64148 9.59161 4.28626 9.2254Z",
                            fill: "#2951A3"
                          }
                        )
                      }
                    ),
                    item[language]
                  ]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.propertyPrice, children: [
              TRANSLATION[language].propertyPriceRange,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex items-center gap-x-0.5", children: /* @__PURE__ */ jsx(
              Input,
              {
                prefix: "Rp",
                placeholder: "0",
                containerClassName: "w-full",
                type: "text",
                value: formatNumber(formData.propertyPrice || 0),
                onChange: (e) => {
                  const rawValue = e.target.value.replace(/\D/g, "");
                  const numericValue = rawValue ? +rawValue : 0;
                  if (numericValue > 1e12)
                    return;
                  updateForm({
                    propertyPrice: numericValue
                  });
                }
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(Label, { className: "font-medium", children: [
              TRANSLATION[language].propertyLocation,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx(
              LocationSuggestion,
              {
                language,
                locationUrl,
                value: formData.location ? formData.location.title : "",
                onChange: (location) => {
                  updateForm({
                    location: {
                      city: location.city?.name,
                      district: location.district?.name,
                      province: location.province?.name,
                      title: location.title,
                      uuid: location.uuid
                    }
                  });
                },
                onFetchLocationSuggestion
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.eta, children: [
              TRANSLATION[language].applyTiming,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: ETA.map((item) => {
              const isActive = formData.eta === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ eta: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "border-none bg-greyBorder w-full h-[0.5px]" })
        ] }),
        /* @__PURE__ */ jsx(PrivacyInfo_default, { className: "mt-5" }),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              onSubmitForm();
            },
            type: "button",
            disabled: disabled || isLoading,
            className: "h-12 flex items-center justify-center bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-3 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: buttonText || TRANSLATION[language].continue
          }
        ),
        isLoading && /* @__PURE__ */ jsx(LoaderFull_default, {})
      ]
    }
  );
};
var ModalFormStepTwo = ({
  buttonText,
  title,
  language = "id",
  children,
  onSubmit,
  isLoading,
  firstName,
  initForm,
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { jobType: "", jobStatus: "" });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = () => {
    if (!onSubmit)
      return;
    onSubmit({
      ...formData,
      jobType: formData.jobType || "",
      jobStatus: formData.jobStatus || ""
    });
  };
  const getDisabledButton = () => {
    return !formData.jobType || !formData.jobStatus;
  };
  const disabled = getDisabledButton();
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: tailwindHelpers.cn("md:w-[375px] p-4", {
        "overflow-y-hidden p-0": isLoading
      }),
      contentClassName: tailwindHelpers.cn({
        "overflow-y-hidden relative p-4 max-h-[calc(100vh-1rem)]": isLoading
      }),
      title: title || TRANSLATION[language].mortgageDataFill,
      ...props,
      children: [
        /* @__PURE__ */ jsx(HeaderForm_default, { firstName, step: 2, language }),
        /* @__PURE__ */ jsxs("form", { className: "flex flex-col gap-y-4 mt-6", children: [
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsx(LabelWithFlagSuccess, { valid: !!formData.salary, children: TRANSLATION[language].monthlyIncomeRange }),
            /* @__PURE__ */ jsx(
              Input,
              {
                placeholder: "0",
                type: "text",
                className: "text-base !px-4",
                prefix: "Rp",
                value: formData?.salary ? formatNumber(+formData.salary) : "",
                onChange: (e) => {
                  const rawValue = e.target.value.replace(/\D/g, "");
                  const numericValue = rawValue ? +rawValue : 0;
                  if (numericValue > 1e12)
                    return;
                  updateForm({
                    salary: numericValue
                  });
                }
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-[#868D9A] font-medium text-xs leading-4", children: TRANSLATION[language].dataUsage })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.jobStatus, children: [
              TRANSLATION[language].employmentStatus,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: JOB_STATUS.map((item) => {
              const isActive = formData.jobStatus === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ jobStatus: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!formData.jobType, children: [
              TRANSLATION[language].occupationType,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: JOB_TYPE.map((item) => {
              const isActive = formData.jobType === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ jobType: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsx(Label, { children: TRANSLATION[language].employmentLength }),
            /* @__PURE__ */ jsx(
              Input,
              {
                placeholder: "2",
                type: "text",
                className: "text-base !px-4",
                suffix: "Tahun",
                value: formData.workLength || "",
                onChange: (e) => {
                  const rawValue = e.target.value.replace(/\D/g, "");
                  const numericValue = rawValue ? +rawValue : 0;
                  updateForm({
                    workLength: numericValue
                  });
                }
              }
            )
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "border-none bg-greyBorder w-full h-[0.5px]" })
        ] }),
        /* @__PURE__ */ jsx(PrivacyInfo_default, { className: "mt-5" }),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              onSubmitForm();
            },
            type: "button",
            disabled: disabled || isLoading,
            className: "h-12 flex items-center justify-center bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-3 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: buttonText
          }
        ),
        isLoading && /* @__PURE__ */ jsx(LoaderFull_default, {})
      ]
    }
  );
};
var ModalBaseBasic = ({
  buttonText = "Ajukan",
  title = "Data untuk KPR",
  children,
  initForm,
  onSubmit,
  isModalBaseBasic,
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", phoneNumber: "" });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber
    });
  };
  const getDisabledButton = () => {
    if (isModalBaseBasic) {
      return !formData.name || !formData.phoneNumber;
    }
    return !formData.name || !formData.phoneNumber;
  };
  return /* @__PURE__ */ jsx(
    ModalBaseData,
    {
      disabled: getDisabledButton(),
      className: "md:w-[375px]",
      title,
      updateForm,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      ...formData,
      childrenBeforeForm: /* @__PURE__ */ jsx("p", { className: "text-sm text-accent", children: "Silahkan Masukan Nama & Nomor Telepon untuk bisa berkomunikasi dengan kami" }),
      contentClassName: "gap-y-5"
    }
  );
};
var ModalBaseWithSalary = ({
  title,
  children,
  initForm,
  onSubmit,
  isModalBaseBasic,
  language = "id",
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", email: "", phoneNumber: "", salary: void 0 });
  useEffect(() => {
    if (!initForm)
      return;
    setFormData(initForm);
  }, [initForm]);
  const [isAggreTnc, setAggressTnc] = useState(true);
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber,
      salary: +(formData?.salary || 0)
    });
  };
  const getDisabledButton = () => {
    if (isModalBaseBasic) {
      return !formData.name || !formData.phoneNumber;
    }
    return !formData.name || !formData.phoneNumber || !isAggreTnc;
  };
  return /* @__PURE__ */ jsx(
    ModalBaseData,
    {
      disabled: getDisabledButton(),
      className: "md:w-[420px]",
      title,
      updateForm,
      initPrefix: initForm?.prefixedPhoneNumber,
      name: formData.name,
      phoneNumber: formData.phoneNumber,
      language,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      children: !isModalBaseBasic && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx(Label, { children: TRANSLATION[language].monthlyIncomeRange }),
          /* @__PURE__ */ jsx(
            Input,
            {
              placeholder: "0",
              type: "text",
              className: "text-base !px-4",
              prefix: "Rp",
              value: formData?.salary ? formatNumber(+formData.salary) : "",
              onChange: (e) => {
                const rawValue = e.target.value.replace(/\D/g, "");
                const numericValue = rawValue ? +rawValue : 0;
                if (numericValue > 1e12)
                  return;
                updateForm({
                  salary: numericValue
                });
              }
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "text-accent font-medium text-xs", children: TRANSLATION[language].dataUsage })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            name: "mortgage-tnc",
            onChange: (value) => {
              setAggressTnc(value.length > 0);
            },
            value: isAggreTnc ? ["mortgage-tnc"] : [],
            children: /* @__PURE__ */ jsx(
              CheckboxItem,
              {
                id: "mortgage-tnc",
                label: /* @__PURE__ */ jsxs(Fragment, { children: [
                  language === "id" && /* @__PURE__ */ jsxs("span", { className: "text-greyText font-medium text-xs", children: [
                    "Saya setuju dengan",
                    " ",
                    /* @__PURE__ */ jsx(
                      "a",
                      {
                        className: "text-primary30 no-underline",
                        title: "Kebijakan Privasi",
                        href: "/kebijakan-privasi/",
                        target: "_blank",
                        children: "Kebijakan Privasi"
                      }
                    ),
                    " ",
                    "Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner bank."
                  ] }),
                  language === "en" && /* @__PURE__ */ jsxs("span", { className: "text-greyText font-medium text-xs", children: [
                    "I agree to the",
                    " ",
                    /* @__PURE__ */ jsx(
                      "a",
                      {
                        className: "text-primary30 no-underline",
                        title: "Privacy Policy",
                        href: "/en/privacy-policy/",
                        target: "_blank",
                        children: "Privacy Policy"
                      }
                    ),
                    " ",
                    "of Rumah123 and authorize us to share data with partner banks."
                  ] })
                ] }),
                value: "mortgage-tnc"
              }
            )
          }
        ) })
      ] })
    }
  );
};
var ModalBaseWithEmail = ({
  buttonText = "Ajukan",
  title = "Data untuk KPR",
  children,
  initForm,
  onSubmit,
  isModalBaseBasic,
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", email: "", phoneNumber: "" });
  const [isAggreTnc, setAggressTnc] = useState(true);
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber
    });
  };
  const getDisabledButton = () => {
    if (isModalBaseBasic) {
      return !formData.name || !formData.phoneNumber;
    }
    return !formData.name || !formData.phoneNumber || !isAggreTnc;
  };
  return /* @__PURE__ */ jsxs(
    ModalBaseData,
    {
      disabled: getDisabledButton(),
      className: "md:w-[420px]",
      title,
      updateForm,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      ...formData,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx(Label, { children: "Email (Opsional)" }),
          /* @__PURE__ */ jsx(
            Input,
            {
              placeholder: "Tulis Email",
              type: "text",
              className: "text-base !px-4",
              value: formData.email,
              onChange: (e) => {
                updateForm({
                  email: e.target.value
                });
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            name: "mortgage-tnc",
            onChange: (value) => {
              setAggressTnc(value.length > 0);
            },
            value: isAggreTnc ? ["mortgage-tnc"] : [],
            children: /* @__PURE__ */ jsx(
              CheckboxItem,
              {
                id: "mortgage-tnc",
                label: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("span", { className: "text-greyText text-xs", children: [
                  "Saya setuju dengan",
                  " ",
                  /* @__PURE__ */ jsx(
                    "a",
                    {
                      className: "text-primary30 no-underline",
                      title: "Kebijakan Privasi",
                      href: "/kebijakan-privasi/",
                      target: "_blank",
                      children: "Kebijakan Privasi"
                    }
                  ),
                  " ",
                  "Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner terkait."
                ] }) }),
                value: "mortgage-tnc"
              }
            )
          }
        ) })
      ]
    }
  );
};
var ModalBaseWithQuestion = ({
  buttonText = "Kirim",
  title = "Konsultasi KPR",
  children,
  initForm,
  onSubmit,
  language = "id",
  ...props
}) => {
  const [formData, setFormData] = useState(initForm || { name: "", phoneNumber: "", question: "" });
  const updateForm = (data) => {
    setFormData((prev) => {
      return {
        ...prev,
        ...data
      };
    });
  };
  const onSubmitForm = (prefixPhoneNumber) => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      formData.phoneNumber || ""
    );
    onSubmit({
      ...formData,
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber,
      question: formData.question || ""
    });
  };
  const getDisabledButton = () => {
    return !formData.name || !formData.phoneNumber || !formData.question;
  };
  return /* @__PURE__ */ jsx(
    ModalBaseData,
    {
      disabled: getDisabledButton(),
      className: "md:w-[375px] p-4",
      title,
      updateForm,
      showLoaderFull: true,
      ...props,
      onSubmit: ({ prefixPhoneNumber }) => {
        onSubmitForm(prefixPhoneNumber);
      },
      contentClassName: "gap-y-5",
      buttonText,
      name: formData.name,
      phoneNumber: formData.phoneNumber,
      language,
      children: /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
        /* @__PURE__ */ jsxs(Label, { className: "flex items-center", children: [
          TRANSLATION[language].question,
          " ",
          /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
        ] }),
        /* @__PURE__ */ jsx(
          "textarea",
          {
            placeholder: "Apa yang ingin kamu tahu?",
            className: "w-full resize-none no-scrollbar text-base !px-4 font-medium py-2 outline-none border border-solid border-greyBorder placeholder:text-disabledText flex flex-grow items-stretch rounded-md",
            required: true,
            rows: 3,
            value: formData.question,
            maxLength: 200,
            onChange: (e) => {
              updateForm({
                question: e.target.value
              });
            }
          }
        ),
        /* @__PURE__ */ jsxs("span", { className: "block w-max ml-auto text-accent font-medium text-xs", children: [
          (formData.question || "")?.length,
          " / 200"
        ] })
      ] })
    }
  );
};
var ModalEnquiryRenovation = ({
  buttonText = "Mulai Konsultasi",
  title = "Lengkapi Data Diri",
  onSubmit,
  locationUrl,
  initForm,
  isLoading,
  language = "id",
  ...props
}) => {
  const [form, setForm] = useState({
    renovationTime: "",
    location: void 0,
    requireMultiguna: void 0,
    amount: void 0,
    requireArsitek: void 0,
    requireDesignInterior: void 0,
    requireKontraktor: void 0,
    ...initForm || {}
  });
  const formRef = useRef(null);
  const [isScrolled, setScrolled] = useState(false);
  useEffect(() => {
    const element = formRef.current;
    if (!element)
      return;
    const listener = () => {
      if (element.scrollTop > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    listener();
    element.addEventListener("scroll", listener);
    return () => {
      element.removeEventListener("scroll", listener);
    };
  }, [formRef]);
  useEffect(() => {
  }, []);
  const updateForm = (data) => {
    setForm((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const onSubmitForm = (data) => {
    if (!onSubmit)
      return;
    onSubmit(data);
  };
  const checkIfDisabled = () => {
    const requiredForm = [
      form.renovationTime,
      form.location,
      typeof form.requireMultiguna === "boolean"
    ].some((item) => Boolean(!item));
    if (requiredForm)
      return true;
    if (form.requireMultiguna && !form.amount) {
      return true;
    }
    return false;
  };
  const disabledSubmit = checkIfDisabled();
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: "md:w-[492px]",
      title,
      ...props,
      children: [
        /* @__PURE__ */ jsxs(
          "form",
          {
            className: "flex flex-col gap-y-4 max-h-[340px] overflow-y-auto no-scrollbar pb-4",
            onScroll: (e) => {
              e.currentTarget.getBoundingClientRect();
              const isCurrenctScrolled = e.currentTarget.scrollTop > 0;
              if (isScrolled !== isCurrenctScrolled) {
                setScrolled(isCurrenctScrolled);
              }
            },
            ref: formRef,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!form.renovationTime, children: [
                  "Waktu Mulai Renovasi ",
                  /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                ] }),
                /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: ETA.map((item) => {
                  const isActive = form.renovationTime === item.value;
                  return /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      isActive,
                      onClick: () => {
                        if (isActive)
                          return;
                        updateForm({ renovationTime: item.value });
                      },
                      children: item[language]
                    },
                    item.value
                  );
                }) })
              ] }),
              /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(Label, { children: [
                  "Lokasi Properti ",
                  /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                ] }),
                /* @__PURE__ */ jsx(
                  LocationSuggestion,
                  {
                    locationUrl,
                    value: form.location ? form.location.title : "",
                    onChange: (location) => {
                      updateForm({
                        location
                      });
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(
                  LabelWithFlagSuccess,
                  {
                    valid: typeof form.requireMultiguna === "boolean",
                    children: [
                      "Apa kamu butuh dana pinjaman?",
                      " ",
                      /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-2", children: [
                  /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      isActive: form.requireMultiguna === true,
                      onClick: () => {
                        if (form.requireMultiguna)
                          return;
                        updateForm({ requireMultiguna: true });
                      },
                      children: "Ya"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      isActive: form.requireMultiguna === false,
                      onClick: () => {
                        if (form.requireMultiguna === false)
                          return;
                        updateForm({ requireMultiguna: false });
                      },
                      children: "Tidak"
                    }
                  )
                ] })
              ] }),
              form.requireMultiguna && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!form.amount, children: [
                  "Dana Pinjaman ",
                  /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
                ] }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    prefix: "Rp",
                    placeholder: "{besaran dana renovasi}",
                    containerClassName: "w-full",
                    type: "text",
                    value: formatNumber(form.amount || 0),
                    onChange: (e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      const numericValue = rawValue ? +rawValue : 0;
                      if (numericValue > 1e12)
                        return;
                      updateForm({
                        amount: numericValue
                      });
                    }
                  }
                )
              ] }) }),
              /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
              /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsx(Label, { className: "mb-1 block", children: "Pilih jasa yang kamu butuhkan" }),
                /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-2", children: [
                  /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      className: "rounded-full",
                      isActive: !!form.requireKontraktor,
                      onClick: () => {
                        updateForm({ requireKontraktor: !form.requireKontraktor });
                      },
                      children: "Kontraktor"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      className: "rounded-full",
                      isActive: !!form.requireArsitek,
                      onClick: () => {
                        updateForm({ requireArsitek: !form.requireArsitek });
                      },
                      children: "Arsitek"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    ChipSelection2,
                    {
                      className: "rounded-full",
                      isActive: !!form.requireDesignInterior,
                      onClick: () => {
                        updateForm({
                          requireDesignInterior: !form.requireDesignInterior
                        });
                      },
                      children: "Desain Interior"
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: tailwindHelpers.cn("-mx-6 px-6 pt-4", {
              "shadow-[0px_-2px_4px_0px_rgba(0,0,0,0.08)]": isScrolled
            }),
            children: /* @__PURE__ */ jsx(
              "button",
              {
                onClick: () => {
                  onSubmitForm({
                    ...form,
                    amount: form.requireMultiguna ? form.amount : void 0
                  });
                },
                disabled: disabledSubmit || isLoading,
                className: "bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-auto disabled:bg-disabledGreyLight disabled:text-[#738492]",
                children: isLoading ? /* @__PURE__ */ jsx(Loader_default, {}) : buttonText
              }
            )
          }
        )
      ]
    }
  );
};
var OTP_NUMBER_LENGTH2 = 6;
var OtpFormComponent = ({
  onChangePhoneNumber,
  onResend,
  onResetError,
  onSubmit,
  errorOtp,
  phoneNumber,
  resendTimeout,
  language = "id"
}) => {
  const { register, getValues, setValue } = useForm();
  const handleInput = (event) => {
    event.preventDefault();
    const {
      target: { name, value }
    } = event;
    const values = getValues();
    const otpCodes = Object.values({
      ...values,
      [name]: value
    }).join("");
    if (otpCodes.length === OTP_NUMBER_LENGTH2) {
      onSubmit(otpCodes);
      return;
    } else {
      onResetError();
    }
    if (event.target.value.length && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      return;
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Backspace" && !event.target.value) {
      event.target.previousElementSibling?.focus();
    }
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const text = event.clipboardData.getData("text/plain");
    text.split("").forEach((char, index) => {
      setValue(String(index), char);
    });
    if (OTP_NUMBER_LENGTH2 === text.length) {
      onSubmit(Object.values({ ...text }).join(""));
    }
  };
  const renderTimeout = (timeout) => {
    if (!timeout)
      return `00`;
    if (timeout < 10)
      return `0${timeout}`;
    return timeout;
  };
  const renderNumber = useMemo(() => {
    return Array.from(Array(OTP_NUMBER_LENGTH2).keys()).map((index) => {
      return /* @__PURE__ */ createElement(
        "input",
        {
          ...register(String(index)),
          key: `otp-num-${index}`,
          inputMode: "numeric",
          onInput: handleInput,
          onKeyDown: handleKeyDown,
          onPaste: handlePaste,
          pattern: "\\d*",
          type: "number",
          autoComplete: "off",
          autoFocus: index === 0,
          className: tailwindHelpers.cn(
            "r123-otp-input",
            "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            {
              "border-0 border-b-2 border-solid text-center w-8 md:w-10 focus-visible:outline-none": true,
              "text-2xl text-primary": true,
              "border-b-neutral30": !errorOtp,
              "border-b-errorAlert": errorOtp
            }
          )
        }
      );
    });
  }, [handleInput, handleKeyDown, handlePaste]);
  return /* @__PURE__ */ jsxs("form", { className: "mx-auto", noValidate: true, children: [
    /* @__PURE__ */ jsxs("p", { className: "font-normal my-4 text-xs", children: [
      language === "id" && /* @__PURE__ */ jsxs(Fragment, { children: [
        "Silahkan masukan ",
        OTP_NUMBER_LENGTH2,
        " digit kode OTP yang telah kami kirimkan ke nomor ",
        phoneNumber
      ] }),
      language === "en" && /* @__PURE__ */ jsxs(Fragment, { children: [
        "Please enter the ",
        OTP_NUMBER_LENGTH2,
        "-digit OTP (One-Time Password) that we have sent to the number ",
        phoneNumber
      ] }),
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "p-0 px-1 bg-transparent outline-none border-none underline inline-flex text-primary cursor-pointer",
          onClick: onChangePhoneNumber,
          children: TRANSLATION[language].changeNumber
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex justify-center mt-4 mx-0 mb-6 gap-4", children: renderNumber }),
    errorOtp && /* @__PURE__ */ jsx("div", { className: "text-errorAlert text-xs font-normal mb-6", children: TRANSLATION[language].wrongOTP }),
    Boolean(resendTimeout) ? /* @__PURE__ */ jsxs("p", { className: "text-xs mb-4 text-center", children: [
      TRANSLATION[language].resend,
      " OTP? (00:",
      renderTimeout(resendTimeout),
      ")"
    ] }) : /* @__PURE__ */ jsxs("div", { className: "text-xs mb-4 text-center", children: [
      /* @__PURE__ */ jsx("p", { className: "m-0 mb-3", children: TRANSLATION[language].wrongOTP }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: "m-auto p-0 px-2 underline text-xs bg-white text-primary flex items-center gap-x-1 outline-none border-none cursor-pointer",
          title: `${TRANSLATION[language].resend} ${resendTimeout ? resendTimeout : ""}`,
          disabled: Boolean(resendTimeout),
          onClick: onResend,
          children: [
            /* @__PURE__ */ jsx(
              "svg",
              {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M13.1997 7.98909C13.1997 7.25434 13.0551 6.55086 12.7659 5.87864C12.4767 5.20643 12.0898 4.62801 11.6051 4.14339C11.1205 3.65877 10.5421 3.27185 9.86989 2.98264C9.19768 2.69343 8.49419 2.54883 7.75945 2.54883C6.8371 2.54883 5.97534 2.76769 5.17415 3.20541C4.37296 3.64313 3.72029 4.24109 3.21613 4.99929C2.71196 5.75749 2.4208 6.59776 2.34264 7.5201L1.79158 6.44143C1.76031 6.37108 1.7095 6.32223 1.63915 6.29487C1.56881 6.26751 1.49846 6.27337 1.42811 6.31246L1.33431 6.34763C1.26396 6.38671 1.21902 6.44338 1.19948 6.51764C1.17994 6.59189 1.18971 6.6642 1.22879 6.73454L2.14332 8.52842L2.15504 8.52842L2.15504 8.54015L2.21367 8.6574C2.2293 8.68084 2.24493 8.70039 2.26056 8.71602C2.2762 8.73165 2.29378 8.74533 2.31333 8.75705C2.33287 8.76878 2.35436 8.77855 2.37781 8.78637C2.44816 8.802 2.51851 8.79028 2.58885 8.75119L2.7061 8.68084L4.44136 7.567C4.50389 7.52792 4.54688 7.47125 4.57033 7.39699C4.59378 7.32273 4.58596 7.25043 4.54688 7.18008L4.48826 7.09801C4.44917 7.03548 4.39055 6.99835 4.31239 6.98663C4.23422 6.9749 4.16387 6.99249 4.10134 7.03939L3.08129 7.68425C3.13601 6.87915 3.37832 6.14049 3.80822 5.46828C4.23813 4.79606 4.80287 4.2665 5.50244 3.87958C6.20202 3.49267 6.95435 3.29921 7.75945 3.29921C8.39258 3.29921 8.99836 3.42427 9.57678 3.6744C10.1552 3.92453 10.6554 4.25868 11.0775 4.67686C11.4996 5.09504 11.8338 5.59334 12.08 6.17176C12.3262 6.75018 12.4493 7.35595 12.4493 7.98909C12.4493 8.84108 12.2402 9.62859 11.8221 10.3516C11.4039 11.0746 10.8333 11.6452 10.1102 12.0634C9.38723 12.4816 8.60363 12.6907 7.75945 12.6907C7.01688 12.6907 6.31731 12.5265 5.66073 12.1983C5.00414 11.87 4.45308 11.4088 4.00754 10.8147C3.96846 10.76 3.91765 10.7209 3.85512 10.6975C3.79259 10.674 3.7281 10.6662 3.66167 10.674C3.59523 10.6819 3.53465 10.7053 3.47993 10.7444C3.40177 10.8069 3.35487 10.889 3.33924 10.9906C3.3236 11.0922 3.34705 11.186 3.40958 11.272C3.92547 11.9599 4.56447 12.4933 5.32657 12.8724C6.08868 13.2515 6.89964 13.4411 7.75945 13.4411C9.12733 13.4411 10.3232 12.9877 11.3472 12.081C12.3321 11.2134 12.9261 10.1347 13.1294 8.84499C13.1763 8.55578 13.1997 8.27048 13.1997 7.98909Z",
                    fill: "#2951A3"
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx("span", { children: TRANSLATION[language].resend })
          ]
        }
      )
    ] })
  ] });
};
var OTPForm_default = memo(OtpFormComponent);
var useCountdown = (initialSeconds) => {
  const [isStarted, setStarted] = useState(false);
  const [seconds, setSeconds] = useState(initialSeconds || 59);
  useEffect(() => {
    if (isStarted && seconds) {
      const secondsLeft = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1e3);
      return () => clearInterval(secondsLeft);
    }
  }, [isStarted, seconds]);
  const start = () => {
    setStarted(true);
  };
  const restart = () => {
    setSeconds(initialSeconds || 60);
  };
  const reset = () => {
    setStarted(false);
    setSeconds(initialSeconds || 60);
  };
  return [seconds, start, restart, reset];
};
var useCountdown_default = useCountdown;
var ModalOTP = ({
  title,
  children,
  phoneNumber,
  errorOtp,
  onSubmit,
  onChangePhoneNumber,
  onResend,
  onResetError,
  language = "id",
  ...props
}) => {
  useEffect(() => {
    if (!props.open) {
      resetCountdown();
    } else {
      startCountdown();
    }
    if (!onResetError)
      return;
    onResetError();
  }, [props.open]);
  const [secondsLeft, startCountdown, _, resetCountdown] = useCountdown_default();
  const [isLoading, setLoading] = useState(false);
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: "md:w-[420px]",
      title: title || TRANSLATION[language].phoneVerification,
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          OTPForm_default,
          {
            language,
            onSubmit: (otp) => {
              if (!onSubmit)
                return;
              onSubmit(otp);
            },
            errorOtp: errorOtp || false,
            onResetError: () => {
              if (!onResetError)
                return;
              onResetError();
            },
            phoneNumber: phoneNumber || "",
            resendTimeout: secondsLeft,
            onResend: () => {
              if (!onResend)
                return;
              setLoading(true);
              onResend({
                phoneNumber: phoneNumber || "",
                callback: () => {
                  setLoading(false);
                  resetCountdown();
                  startCountdown();
                }
              });
            },
            onChangePhoneNumber: () => {
              if (onChangePhoneNumber) {
                onChangePhoneNumber();
              }
              resetCountdown();
            }
          }
        ),
        isLoading && /* @__PURE__ */ jsx(LoaderFull_default, {})
      ]
    }
  );
};
var ModalChangePhoneNumber = ({
  title,
  buttonText,
  initSelectedPrefix = "+62",
  initPhoneNumber = "",
  children,
  onSubmit,
  isLoading,
  language = "id",
  ...props
}) => {
  const [prefixPhoneNumber, setPrefixPhoneNumber] = useState(initSelectedPrefix);
  const [phoneNumber, setSelectedPhoneNumber] = useState(initPhoneNumber);
  useEffect(() => {
    if (initPhoneNumber === phoneNumber)
      return;
    setSelectedPhoneNumber(phoneNumber);
  }, [initPhoneNumber]);
  useEffect(() => {
    if (initSelectedPrefix === prefixPhoneNumber)
      return;
    setPrefixPhoneNumber(initSelectedPrefix);
  }, [initSelectedPrefix]);
  const onSubmitForm = () => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      phoneNumber || ""
    );
    onSubmit({
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber
    });
  };
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: "md:w-[420px]",
      title: title || TRANSLATION[language].changeNumber,
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            placeholder: TRANSLATION[language].placeHolderPhone,
            type: "text",
            className: "text-base !px-4 relative",
            containerClassName: "relative",
            required: true,
            prefix: /* @__PURE__ */ jsx(
              PhoneInputList_default,
              {
                value: prefixPhoneNumber,
                onChange: (value) => {
                  setPrefixPhoneNumber(value);
                }
              }
            ),
            value: phoneNumber,
            onChange: (e) => {
              const rawValue = e.target.value.replace(/\D/g, "");
              const numericValue = rawValue ?? "";
              setSelectedPhoneNumber(numericValue);
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              onSubmitForm();
            },
            disabled: !phoneNumber || isLoading,
            className: "bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-10 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: isLoading ? /* @__PURE__ */ jsx(Loader_default, {}) : buttonText || TRANSLATION[language].phoneVerification
          }
        )
      ]
    }
  );
};
var SuccessAlert = ({ children }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: tailwindHelpers.cn(
        "z-[1000] left-1/2 translate-x-[-50%] fixed top-4 rounded-md flex gap-x-2 w-max items-center bg-[#EBF8F6] text-accent px-2 py-1 shadow-sm border border-solid border-keppel"
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "svg",
          {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "shrink-0",
            children: [
              /* @__PURE__ */ jsx("circle", { cx: "9", cy: "9", r: "8", fill: "#38BAA7", stroke: "#EBF8F6" }),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M5.83301 9.25033L7.91634 11.3337L12.083 7.16699",
                  stroke: "white",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx("span", { className: "font-medium shrink-0 text-sm", children })
      ]
    }
  );
};
var ModalSuccess = ({
  title,
  subTitle,
  className,
  language = "id",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    DialogSuccess,
    {
      ...props,
      className: tailwindHelpers.cn(
        "w-[450px] bg-[#2951a3] !p-8 md:max-h-[calc(100vh-1rem)] max-h-full md:h-[508px] h-full flex justify-center items-center text-center md:rounded-t-2xl rounded-t-none",
        className
      ),
      title: title || TRANSLATION[language].dataSentSuccess,
      subTitle: subTitle || TRANSLATION[language].dataConfirmation
    }
  );
};
var ModalDetailData = ({
  buttonText,
  title,
  onSubmit,
  locationUrl,
  isLoading,
  language = "id",
  onFetchLocationSuggestion,
  ...props
}) => {
  const [form, setForm] = useState({
    eta: void 0,
    desired: void 0,
    showProperty: false,
    jobType: void 0,
    marriageStatus: void 0,
    workLength: void 0,
    minPrice: void 0,
    maxPrice: void 0,
    location: void 0
  });
  const updateForm = (data) => {
    setForm((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const checkIfDisabled = () => {
    const requiredForm = [form.eta, form.desired, form.jobType].some(
      (item) => Boolean(!item)
    );
    if (requiredForm)
      return true;
    if (form.showProperty) {
      const hasDesired = form.desired === HAS_DESIRED_PROPERTY[0].value;
      const requiredForm2 = [
        form.minPrice,
        form.location,
        hasDesired || form.maxPrice
      ].some((item) => Boolean(!item));
      if (requiredForm2)
        return true;
    }
    return false;
  };
  const disabledSubmit = checkIfDisabled();
  const onSubmitForm = (data) => {
    if (!onSubmit)
      return;
    onSubmit(data);
  };
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      className: "md:w-[492px] md:rounded-t-2xl rounded-t-none md:max-h-[calc(100vh-1rem)] max-h-full md:h-auto h-full",
      title: title || TRANSLATION[language].completePersonalData,
      ...props,
      children: [
        /* @__PURE__ */ jsxs("form", { className: "flex flex-col gap-y-4 md:max-h-[70vh] overflow-y-auto no-scrollbar pb-4 h-[calc(100vh-180px)] md:h-auto", children: [
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!form.eta, children: [
              TRANSLATION[language].applyTiming,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: ETA.map((item) => {
              const isActive = form.eta === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ eta: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!form.desired, children: [
              TRANSLATION[language].desiredProperty,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: HAS_DESIRED_PROPERTY.map((item) => {
              const isActive = form.desired === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ desired: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          form.desired && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
              /* @__PURE__ */ jsxs(Label, { children: [
                TRANSLATION[language].propertyPriceRange,
                " ",
                /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-0.5", children: [
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    prefix: "Rp",
                    placeholder: "0",
                    containerClassName: "w-full",
                    type: "text",
                    value: formatNumber(form.minPrice || 0),
                    onChange: (e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      const numericValue = rawValue ? +rawValue : 0;
                      if (numericValue > 1e12)
                        return;
                      updateForm({
                        minPrice: numericValue
                      });
                    }
                  }
                ),
                form.desired === HAS_DESIRED_PROPERTY[1].value && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx("div", { className: "w-6 h-1 bg-disabled" }),
                  /* @__PURE__ */ jsx(
                    Input,
                    {
                      prefix: "Rp",
                      placeholder: "0",
                      containerClassName: "w-full",
                      type: "text",
                      value: formatNumber(form.maxPrice || 0),
                      onChange: (e) => {
                        const rawValue = e.target.value.replace(/\D/g, "");
                        const numericValue = rawValue ? +rawValue : 0;
                        if (numericValue > 1e12)
                          return;
                        updateForm({
                          maxPrice: numericValue
                        });
                      }
                    }
                  )
                ] })
              ] })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
              /* @__PURE__ */ jsxs(Label, { children: [
                TRANSLATION[language].propertyLocation,
                " ",
                /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
              ] }),
              /* @__PURE__ */ jsx(
                LocationSuggestion,
                {
                  language,
                  locationUrl,
                  value: form.location ? form.location.title : "",
                  onChange: (location) => {
                    updateForm({
                      location
                    });
                  },
                  onFetchLocationSuggestion
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsxs(LabelWithFlagSuccess, { valid: !!form.jobType, children: [
              TRANSLATION[language].occupationType,
              " ",
              /* @__PURE__ */ jsx("span", { className: "text-errorAlert", children: "*" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: JOB_TYPE.map((item) => {
              const isActive = form.jobType === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ jobType: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsx(Label, { children: TRANSLATION[language].employmentLength }),
            /* @__PURE__ */ jsx(
              Input,
              {
                placeholder: "2",
                type: "text",
                className: "text-base !px-4",
                suffix: "Tahun",
                value: form.workLength || "",
                onChange: (e) => {
                  const rawValue = e.target.value.replace(/\D/g, "");
                  const numericValue = rawValue ? +rawValue : 0;
                  updateForm({
                    workLength: numericValue
                  });
                }
              }
            )
          ] }),
          /* @__PURE__ */ jsx("hr", { className: "bg-greyBorder h-[1px] w-full border-0" }),
          /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ jsx(LabelWithFlagSuccess, { valid: !!form.marriageStatus, children: TRANSLATION[language].maritalStatus }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: MARRIAGE_STATUS.map((item) => {
              const isActive = form.marriageStatus === item.value;
              return /* @__PURE__ */ jsx(
                ChipSelection2,
                {
                  isActive,
                  onClick: () => {
                    if (isActive)
                      return;
                    updateForm({ marriageStatus: item.value });
                  },
                  children: item[language]
                },
                item.value
              );
            }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              const hasDesired = form.desired === HAS_DESIRED_PROPERTY[0].value;
              const dataMortgage = {
                eta: form.eta,
                desiredProperty: hasDesired ? "ALREADY_NOT_IN_R123" /* AlreadyNotInR123 */ : "NOT_YET" /* NotYet */,
                price: {
                  minValue: form.minPrice,
                  maxValue: hasDesired ? form.minPrice : form.maxPrice
                },
                locationUuid: form.location?.uuid || "",
                location: form.location?.title,
                province: form.location?.province?.name,
                city: form.location?.city?.name,
                district: form.location?.district?.name,
                jobType: form.jobType,
                workLength: form.workLength,
                marriageStatus: form.marriageStatus
              };
              onSubmitForm(dataMortgage);
            },
            disabled: disabledSubmit,
            className: "bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-10 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: isLoading ? /* @__PURE__ */ jsx(Loader_default, {}) : buttonText || TRANSLATION[language].send
          }
        )
      ]
    }
  );
};
var useOtp = (baseUrl, path) => {
  const [isShowModalBase, setShowModalBase] = useState(false);
  const [isShowOtp, setShowOTP] = useState(false);
  const [isShowChangePhoneNumber, setShowChangePhoneNumber] = useState(false);
  const [errorOtp, setErrorOtp] = useState(false);
  const [otpForm, setOtpForm, refetchCookie] = useCookiesState(
    OTP_ENQUIRY_COOKIE_KEY,
    DEFAULT_OTP_ENQUIRY_COOKIE_VALUE,
    ENQUIRY_COOKIES_EXPIRE_DURATION
  );
  const [isSuccessOTP, setShowSuccessOTP] = useState(false);
  const requestEnquiryOtp = async (phoneNumber, type) => {
    const url = path ? baseUrl : `${baseUrl}/otp/request/?key=nfzz8k68SNqU5cfdxaKzWtAdi`;
    return requestOtp({
      url,
      payload: {
        phoneNumber,
        cancelledRequestId: otpForm?.requestId,
        portalId: 1 /* rumah123 */,
        type: type || "SMS" /* Sms */,
        ...path && { path: `${path}/otp/request/` }
      }
    });
  };
  const verifyEnquiryOtp = async (code, type) => {
    const url = path ? baseUrl : `${baseUrl}/otp/verify/?key=nfzz8k68SNqU5cfdxaKzWtAdi`;
    return verifyOtp({
      url,
      payload: {
        requestId: otpForm?.requestId || "",
        code,
        type: type || "SMS" /* Sms */,
        ...path && { path: `${path}/otp/verify/` }
      }
    });
  };
  return {
    data: {
      otpForm,
      isShowModalBase,
      isShowChangePhoneNumber,
      isShowOtp,
      errorOtp,
      isSuccessOTP
    },
    action: {
      setShowModalBase,
      setShowOTP,
      setShowChangePhoneNumber,
      setErrorOtp,
      setOtpForm,
      refetchCookie,
      requestEnquiryOtp,
      setShowSuccessOTP,
      verifyEnquiryOtp
    }
  };
};
var useEnquiryProviderV2 = ({
  baseUrlOtp,
  pathVerifyOtp,
  pathRequestOtp,
  baseUrlMortgageEnquiry,
  pathMortgageEnquiry,
  otpAPIKey,
  mortgageAPIKey
}) => {
  const [isShowModalBase, setShowModalBase] = useState(false);
  const [isShowOtp, setShowOTP] = useState(false);
  const [isShowChangePhoneNumber, setShowChangePhoneNumber] = useState(false);
  const [errorOtp, setErrorOtp] = useState(false);
  const [otpForm, setOtpForm, refetchCookie] = useCookiesState(
    OTP_ENQUIRY_COOKIE_KEY,
    DEFAULT_OTP_ENQUIRY_COOKIE_VALUE,
    ENQUIRY_COOKIES_EXPIRE_DURATION
  );
  const [enquiryData, setEnquiryData] = useState(
    {}
  );
  const [isSuccessOTP, setShowSuccessOTP] = useState(false);
  const [isSuccessEnquiry, setShowSuccessEnquiry] = useState(false);
  const [isShowModalDetail, setShowModalDetail] = useState(false);
  useEffect(() => {
    if (!isSuccessOTP)
      return;
    setTimeout(() => {
      setShowSuccessOTP(false);
    }, 1500);
  }, [isSuccessOTP]);
  const requestEnquiryOtp = (phoneNumber) => {
    const url = constructUrl({
      baseUrl: baseUrlOtp,
      pathname: pathRequestOtp || "/",
      key: otpAPIKey
    });
    return requestOtp({
      url,
      payload: {
        phoneNumber,
        cancelledRequestId: otpForm?.requestId
      }
    });
  };
  const mortgageEnquiry = (payload) => {
    const url = constructUrl({
      baseUrl: baseUrlMortgageEnquiry,
      pathname: pathMortgageEnquiry || "/",
      key: mortgageAPIKey
    });
    return mortgageEnquiryMutation({
      url,
      payload
    });
  };
  const updateEnquiryData = (data) => {
    setEnquiryData((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const verifyEnquiryOtp = (code) => {
    const url = constructUrl({
      baseUrl: baseUrlOtp,
      pathname: pathVerifyOtp || "/",
      key: otpAPIKey
    });
    return verifyOtp({
      url,
      payload: {
        requestId: otpForm?.requestId || "",
        code
      }
    });
  };
  return {
    data: {
      otpForm,
      isShowModalBase,
      isShowModalDetail,
      isShowChangePhoneNumber,
      isShowOtp,
      errorOtp,
      isSuccessEnquiry,
      enquiryData,
      isSuccessOTP
    },
    action: {
      setShowModalBase,
      setShowOTP,
      setShowChangePhoneNumber,
      setErrorOtp,
      setOtpForm,
      setShowSuccessEnquiry,
      setShowModalDetail,
      refetchCookie,
      requestEnquiryOtp,
      setShowSuccessOTP,
      verifyEnquiryOtp,
      updateEnquiryData,
      mortgageEnquiry
    }
  };
};
var useEnquiryProviderV2_default = useEnquiryProviderV2;
var EnquiryContextV2 = createContext({
  data: null,
  action: {
    startEnquiry: () => {
    },
    setShowModalBase: () => {
    },
    setShowOTP: () => {
    },
    setShowChangePhoneNumber: () => {
    },
    setShowSuccessEnquiry: () => {
    },
    setShowModalDetail: () => {
    },
    setErrorOtp: () => {
    },
    setShowSuccessOTP: () => {
    },
    mortgageEnquiry: async () => {
      return { success: true, result: {} };
    }
  }
});
var EnquiryProviderV2 = ({
  children,
  flow,
  baseUrlOtp,
  pathVerifyOtp = "/otp/verify/",
  pathRequestOtp = "/otp/request/",
  baseUrlMortgageEnquiry,
  pathMortgageEnquiry = "/kpr-enquiry/",
  baseUrlLocation,
  pathLocation = "/location/suggestion/",
  otpAPIKey = "nfzz8k68SNqU5cfdxaKzWtAdi",
  locationAPIKey = "nfzz8k68SNqU5cfdxaKzWtAdi",
  mortgageAPIKey,
  initEnquiryPayload = {},
  onFinishFlow
}) => {
  const {
    data: {
      isShowModalBase,
      isShowChangePhoneNumber,
      isShowModalDetail,
      isShowOtp,
      isSuccessEnquiry,
      otpForm,
      errorOtp,
      enquiryData,
      isSuccessOTP
    },
    action: {
      refetchCookie,
      setOtpForm,
      requestEnquiryOtp,
      setShowModalBase,
      setShowOTP,
      setShowChangePhoneNumber,
      setShowSuccessEnquiry,
      setShowModalDetail,
      setErrorOtp,
      setShowSuccessOTP,
      verifyEnquiryOtp,
      updateEnquiryData,
      mortgageEnquiry
    }
  } = useEnquiryProviderV2_default({
    baseUrlOtp,
    pathVerifyOtp,
    pathRequestOtp,
    baseUrlMortgageEnquiry,
    pathMortgageEnquiry,
    baseUrlLocation,
    pathLocation,
    otpAPIKey,
    locationAPIKey,
    mortgageAPIKey
  });
  const [isLoading, setLoading] = useState(false);
  const onSuccessModalBase = useRef((data) => {
  });
  const onChangePhoneNumber = useRef(() => {
  });
  const onSuccessChangePhoneNumber = useRef(() => {
  });
  const modalSuccessText = useRef(
    null
  );
  const modalFormTitle = useRef(null);
  const modalFormDetailTitle = useRef(null);
  const modalBaseButtonText = useRef(null);
  const modalDetailButtonText = useRef(null);
  const isByPassOtp = useRef(false);
  const onSuccesOTP = useRef(() => {
  });
  const onSuccessModalDetail = useRef(() => {
  });
  const currentFlow = useRef(flow);
  const [isModalBaseBasic, setModalBaseBasic] = useState(false);
  const startEnquiry = (options) => {
    const {
      enquiryFlow = flow,
      isByPassFlow,
      isInsertDataAfterOTP,
      isByPassOTP
    } = options?.flags || {};
    refetchCookie();
    currentFlow.current = enquiryFlow;
    isByPassOtp.current = isByPassOTP || false;
    modalSuccessText.current = options?.modalSuccessText || null;
    modalFormTitle.current = options?.modalFormTitle || null;
    modalFormDetailTitle.current = options?.modalFormDetailTitle || null;
    modalBaseButtonText.current = options?.modalBaseButtonText || null;
    modalDetailButtonText.current = options?.modalDetailButtonText || null;
    if (enquiryFlow === "base-flow") {
      setModalBaseBasic(true);
      if (isByPassFlow) {
        if (onFinishFlow) {
          onFinishFlow(
            {
              cookieData: {
                ...otpForm,
                formData: {
                  ...otpForm.formData,
                  ...enquiryData
                }
              },
              newFormDataForMortgageRequest: enquiryData,
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: false
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          ).then(() => {
            setShowSuccessEnquiry(true);
          });
        }
        return;
      }
      onSuccessModalBase.current = (data) => {
        setShowModalBase(false);
        if (!isByPassOTP) {
          setShowOTP(true);
          return;
        }
        const { salary, ...value2 } = data || {};
        if (onFinishFlow) {
          onFinishFlow(
            {
              cookieData: {
                ...otpForm,
                ...value2,
                formData: {
                  ...otpForm.formData,
                  ...enquiryData || {},
                  incomePerMonth: salary
                }
              },
              newFormDataForMortgageRequest: enquiryData || {},
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: true
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          ).then(() => {
            setShowSuccessEnquiry(true);
          });
        }
        return;
      };
      onChangePhoneNumber.current = () => {
        setShowOTP(false);
        setShowChangePhoneNumber(true);
      };
      onSuccessChangePhoneNumber.current = () => {
        setShowChangePhoneNumber(false);
        setShowOTP(true);
      };
      onSuccesOTP.current = (otpForm2, enquiryData2) => {
        setShowOTP(false);
        if (onFinishFlow) {
          onFinishFlow(
            {
              cookieData: {
                ...otpForm2,
                formData: {
                  ...otpForm2.formData,
                  ...enquiryData2 || {}
                }
              },
              newFormDataForMortgageRequest: enquiryData2 || {},
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: true
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          ).then(() => {
            setShowSuccessEnquiry(true);
          });
        }
      };
      setShowModalBase(true);
      return;
    }
    if (enquiryFlow === "mortgage-enquiry-new") {
      setModalBaseBasic(false);
      if (isByPassFlow) {
        if (onFinishFlow) {
          onFinishFlow(
            {
              cookieData: {
                ...otpForm,
                formData: {
                  ...otpForm.formData,
                  ...enquiryData
                }
              },
              newFormDataForMortgageRequest: enquiryData,
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: false
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          ).then(() => {
            setShowSuccessEnquiry(true);
          });
        }
        return;
      }
      onSuccessModalBase.current = () => {
        setShowModalBase(false);
        if (isByPassOTP) {
          setShowModalDetail(true);
          return;
        }
        setShowOTP(true);
      };
      onChangePhoneNumber.current = () => {
        setShowOTP(false);
        setShowChangePhoneNumber(true);
      };
      onSuccessChangePhoneNumber.current = () => {
        setShowChangePhoneNumber(false);
        setShowOTP(true);
      };
      onSuccesOTP.current = (otpForm2, enquiryData2) => {
        setShowSuccessOTP(true);
        setShowOTP(false);
        setShowModalDetail(true);
        if (isInsertDataAfterOTP && onFinishFlow) {
          onFinishFlow(
            {
              cookieData: {
                ...otpForm2,
                formData: {
                  ...otpForm2.formData,
                  ...enquiryData2 || {}
                }
              },
              newFormDataForMortgageRequest: enquiryData2 || {},
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: true
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          );
        }
      };
      onSuccessModalDetail.current = ({
        location,
        province,
        city,
        district,
        ...data
      }, otpForm2) => {
        updateEnquiryData(data);
        setOtpForm((c) => {
          return {
            ...c,
            formData: {
              ...c.formData || {},
              ...data,
              location,
              province,
              city,
              district
            },
            location,
            isVerified: true
          };
        });
        if (onFinishFlow) {
          setLoading(true);
          onFinishFlow(
            {
              cookieData: {
                ...otpForm2,
                formData: {
                  province,
                  city,
                  district,
                  ...otpForm2.formData,
                  ...data
                },
                location,
                isVerified: true
              },
              newFormDataForMortgageRequest: {
                ...data,
                location,
                province,
                city,
                district
              },
              param: options?.param,
              flags: {
                ...options?.flags || {},
                enquiryFlow,
                isFinishOtp: false
              }
            },
            {
              ...onFinishActionCallback,
              onFinish: options?.onFinish
            }
          ).then(() => {
            setShowModalDetail(false);
            setShowSuccessEnquiry(true);
            setLoading(false);
          });
        }
      };
      setShowModalBase(true);
      return;
    }
    if (enquiryFlow === "raw") {
      setShowModalBase(true);
    }
  };
  const onFinishActionCallback = {
    mortgageEnquiry,
    hideSuccess: () => {
      setShowSuccessEnquiry(false);
    },
    setEnquiryCookie: (data) => {
      setOtpForm((c) => {
        return {
          ...c,
          ...data
        };
      });
    }
  };
  const value = useMemo(() => {
    return {
      data: {
        newFormDataForMortgageRequest: enquiryData,
        cookieData: otpForm
      },
      action: {
        startEnquiry,
        setShowModalBase,
        setShowOTP,
        setShowChangePhoneNumber,
        setShowSuccessEnquiry,
        setShowModalDetail,
        setErrorOtp,
        setShowSuccessOTP,
        mortgageEnquiry
      }
    };
  }, [otpForm, enquiryData]);
  const initalForm = useMemo(() => {
    return {
      name: otpForm.name,
      phoneNumber: otpForm.phoneNumber,
      salary: otpForm.formData?.incomePerMonth,
      prefixedPhoneNumber: otpForm.prefixPhoneNumber
    };
  }, [
    otpForm.name,
    otpForm.phoneNumber,
    otpForm.formData?.incomePerMonth,
    otpForm.prefixPhoneNumber
  ]);
  return /* @__PURE__ */ jsxs(EnquiryContextV2.Provider, { value, children: [
    isSuccessOTP && /* @__PURE__ */ jsx(SuccessAlert, { children: "OTP Berhasil" }),
    /* @__PURE__ */ jsx(ReactPortalComponent, { children: /* @__PURE__ */ jsx(
      ModalBaseWithSalary,
      {
        title: modalFormTitle.current || void 0,
        buttonText: modalBaseButtonText.current || void 0,
        isModalBaseBasic,
        open: isShowModalBase,
        onClose: () => {
          setShowModalBase(false);
        },
        initForm: initalForm,
        preventCloseOnBackground: true,
        isLoading,
        onSubmit: ({ salary, ...formSubmit }) => {
          if (isByPassOtp.current) {
            onSuccessModalBase.current({
              salary,
              ...formSubmit
            });
            updateEnquiryData({
              ...formSubmit,
              salary
            });
            return;
          }
          setLoading(true);
          requestEnquiryOtp(formSubmit.phoneNumber).then((value2) => {
            if (value2.result.error) {
              return;
            }
            if (value2.result.data) {
              onSuccessModalBase.current();
              setOtpForm((c) => {
                return {
                  ...c,
                  requestId: value2.result.data.requestId
                };
              });
              return;
            }
          }).then(() => {
            setLoading(false);
            setOtpForm((c) => {
              return {
                ...c,
                ...formSubmit,
                formData: {
                  ...c.formData || {},
                  incomePerMonth: salary
                }
              };
            });
            updateEnquiryData({
              ...formSubmit,
              salary
            });
          });
        }
      }
    ) }),
    /* @__PURE__ */ jsx(ReactPortalComponent, { children: /* @__PURE__ */ jsx(
      ModalOTP,
      {
        open: isShowOtp,
        onClose: () => {
          setShowOTP(false);
        },
        preventCloseOnBackground: true,
        isLoading,
        onChangePhoneNumber: () => {
          onChangePhoneNumber.current();
        },
        phoneNumber: otpForm?.phoneNumber,
        errorOtp,
        onResetError: () => {
          setErrorOtp(false);
        },
        onSubmit: (code) => {
          setLoading(true);
          verifyEnquiryOtp(code).then((value2) => {
            if (value2.result.error) {
              setErrorOtp(true);
              return;
            }
            if (value2.result.data) {
              setOtpForm((c) => {
                return {
                  ...c,
                  requestId: "",
                  isVerified: true
                };
              });
              onSuccesOTP.current({
                ...otpForm,
                requestId: "",
                isVerified: true
              });
              return;
            }
            setErrorOtp(true);
            return;
          }).then(() => {
            setLoading(false);
          });
        },
        onResend: ({ phoneNumber, callback }) => {
          setLoading(true);
          requestEnquiryOtp(phoneNumber).then((value2) => {
            if (value2.result.error) {
              return;
            }
            if (value2.result.data) {
              setOtpForm((c) => {
                return {
                  ...c,
                  requestId: value2.result.data.requestId
                };
              });
              setLoading(false);
              callback();
              return;
            }
          }).then(() => {
            setLoading(false);
          });
        }
      }
    ) }),
    /* @__PURE__ */ jsx(ReactPortalComponent, { children: /* @__PURE__ */ jsx(
      ModalChangePhoneNumber,
      {
        open: isShowChangePhoneNumber,
        onClose: () => {
          setShowChangePhoneNumber(false);
        },
        preventCloseOnBackground: true,
        isLoading,
        onSubmit: (value2) => {
          setLoading(true);
          requestEnquiryOtp(value2.phoneNumber).then((value3) => {
            if (value3.result.error) {
              return;
            }
            if (value3.result.data) {
              setOtpForm((c) => {
                return {
                  ...c,
                  requestId: value3.result.data.requestId,
                  prefixPhoneNumber: value3.prefixPhoneNumber
                };
              });
              onSuccessChangePhoneNumber.current();
              return;
            }
          }).then(() => {
            setLoading(false);
            setOtpForm((c) => {
              return {
                ...c,
                ...value2
              };
            });
            updateEnquiryData(value2);
          });
        },
        initPhoneNumber: otpForm?.phoneNumber,
        initSelectedPrefix: otpForm?.prefixPhoneNumber
      },
      otpForm?.phoneNumber || ""
    ) }),
    /* @__PURE__ */ jsx(ReactPortalComponent, { children: /* @__PURE__ */ jsx(
      ModalSuccess,
      {
        title: modalSuccessText.current?.title,
        subTitle: modalSuccessText.current?.subTitle,
        open: isSuccessEnquiry,
        onClose: () => {
          setShowSuccessEnquiry(false);
        }
      }
    ) }),
    /* @__PURE__ */ jsx(ReactPortalComponent, { children: /* @__PURE__ */ jsx(
      ModalDetailData,
      {
        title: modalFormDetailTitle.current || void 0,
        open: isShowModalDetail,
        buttonText: modalDetailButtonText.current || void 0,
        onClose: () => {
          setShowModalDetail(false);
        },
        preventCloseOnBackground: true,
        isLoading,
        locationUrl: {
          baseUrl: baseUrlLocation,
          pathname: pathLocation,
          key: locationAPIKey
        },
        onSubmit: (data) => {
          onSuccessModalDetail.current(data, otpForm);
        }
      }
    ) }),
    children
  ] });
};
var useEnquiryV2 = () => {
  return useContext(EnquiryContextV2);
};
var useModalEntryPoint = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(
    () => Promise.resolve()
  );
  const [isLoading, setIsLoading] = useState(false);
  const openModalEntryPoint = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalEntryPoint = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        const data2 = {
          ...form,
          isLowIntent: form.desiredProperty === "Belum" && form.eta === "> 6 Bulan"
        };
        await onSubmit.current?.(data2);
        close(data2);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalEntryPoint,
    closeModalEntryPoint: close,
    modalEntryPointData: data,
    modalEntryPointState: modal,
    isLoadingEntryPoint: isLoading,
    onSubmitModalEntryPoint: handleSubmitModalEntryPoint
  };
};
var useModalBasic = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(
    () => Promise.resolve()
  );
  const [isLoading, setIsLoading] = useState(false);
  const openModalBasic = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalBasic = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        await onSubmit.current?.(form);
        close(form);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalBasic,
    closeModalBasic: close,
    modalBasicData: data,
    modalBasicState: modal,
    isLoadingBasic: isLoading,
    onSubmitModalBasic: handleSubmitModalBasic
  };
};
var useModalStepOne = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(() => Promise.resolve());
  const [isLoading, setIsLoading] = useState(false);
  const openModalStepOne = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalStepOne = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        await onSubmit.current?.(form);
        close(form);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalStepOne,
    closeModalStepOne: close,
    modalStepOneData: data,
    modalStepOneState: modal,
    isLoadingStepOne: isLoading,
    onSubmitModalStepOne: handleSubmitModalStepOne
  };
};
var useModalStepTwo = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(() => Promise.resolve());
  const [isLoading, setIsLoading] = useState(false);
  const openModalStepTwo = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalStepTwo = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        await onSubmit.current?.(form);
        close(form);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalStepTwo,
    closeModalStepTwo: close,
    modalStepTwoData: data,
    modalStepTwoState: modal,
    isLoadingStepTwo: isLoading,
    onSubmitModalStepTwo: handleSubmitModalStepTwo
  };
};
var useModalQuestionBasic = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(() => Promise.resolve());
  const [isLoading, setIsLoading] = useState(false);
  const openModalQuestionBasic = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalBasicQuestion = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        await onSubmit.current?.(form);
        close(form);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalQuestionBasic,
    closeModalQuestionBasic: close,
    modalBasicQuestionData: data,
    modalBasicQuestionState: modal,
    isLoadingQuestionBasic: isLoading,
    onSubmitModalQuestionBasic: handleSubmitModalBasicQuestion
  };
};

// src/helper/getTrackerPayload.ts
var getTrackerPayload = ({
  name,
  phoneNumber,
  desiredProperty,
  eta,
  location,
  propertyPrice,
  jobStatus,
  jobType,
  workLength,
  salary,
  uuid
}) => {
  return {
    updated_timestamp: Date.now(),
    feature_form_work_status: jobStatus,
    feature_form_name_fill: name,
    feature_form_phone_fill: phoneNumber,
    feature_form_salary_fill: salary,
    feature_form_kpr_readiness: eta,
    feature_form_desired_property: desiredProperty,
    feature_form_work_type: jobType,
    feature_form_work_duration: workLength ? `${workLength} tahun` : void 0,
    feature_form_property_price_target: desiredProperty === "Sudah" ? propertyPrice : void 0,
    feature_form_property_location_target: desiredProperty === "Sudah" ? [location?.district, location?.city, location?.province].filter((item) => item).join(", ") : void 0
  };
};

// ../graphql-codegen/dist/index.mjs
var EnumDesiredProperty = /* @__PURE__ */ ((EnumDesiredProperty2) => {
  EnumDesiredProperty2["AlreadyInR123"] = "ALREADY_IN_R123";
  EnumDesiredProperty2["AlreadyNotInR123"] = "ALREADY_NOT_IN_R123";
  EnumDesiredProperty2["NotYet"] = "NOT_YET";
  return EnumDesiredProperty2;
})(EnumDesiredProperty || {});

// src/helper/getZapierPayload.ts
var getZapierPayload = ({
  name,
  phoneNumber,
  desiredProperty,
  eta,
  location,
  propertyPrice,
  jobStatus,
  jobType,
  workLength,
  salary,
  uuid
}) => {
  return {
    uuid,
    desiredProperty: desiredProperty === "Belum" ? EnumDesiredProperty.NotYet : EnumDesiredProperty.AlreadyNotInR123,
    eta,
    etaMortgage: eta,
    jobType,
    professionType: jobType,
    locationUuid: location?.uuid,
    name,
    phoneNumber,
    price: propertyPrice ? {
      maxValue: propertyPrice,
      minValue: propertyPrice
    } : void 0,
    workLength: workLength ? `${workLength} tahun` : void 0,
    jobStatus,
    incomePerMonth: salary,
    salary: salary ? {
      maxValue: salary,
      minValue: salary
    } : void 0,
    submissionNumber: propertyPrice,
    province: location?.province,
    city: location?.city,
    url: typeof window !== "undefined" ? window.location.href : void 0,
    location: [location?.district, location?.city, location?.province].filter((item) => item).join(", "),
    ...location || {}
  };
};

// src/helper/getCorePayload.ts
var getCorePayload = ({
  name,
  phoneNumber,
  desiredProperty,
  eta,
  location,
  propertyPrice,
  jobStatus,
  jobType,
  workLength,
  salary,
  uuid
}) => {
  return {
    portalId: 1,
    price: propertyPrice ? {
      minValue: propertyPrice,
      maxValue: propertyPrice
    } : void 0,
    locationUuid: location?.uuid,
    name,
    phoneNumber,
    desiredProperty: desiredProperty === "Belum" ? "NOT_YET" /* NotYet */ : "ALREADY_NOT_IN_R123" /* AlreadyNotInR123 */,
    jobType,
    salary: salary ? {
      minValue: salary,
      maxValue: salary
    } : void 0,
    sourceURL: window.location.href,
    workLength,
    uuid: uuid || void 0,
    eta,
    jobStatus
  };
};
var useModalTakeOver = () => {
  const { open, close, data, modal } = useAsyncModal();
  const onSubmit = useRef(() => Promise.resolve());
  const [isLoading, setIsLoading] = useState(false);
  const openModalTakeOver = useCallback(
    (params) => {
      onSubmit.current = params.onSubmit;
      return open(params.data);
    },
    [open]
  );
  const handleSubmitModalTakeOver = useCallback(
    async (form) => {
      try {
        setIsLoading(true);
        await onSubmit.current?.(form);
        close(form);
      } catch (err) {
        console.error({ err });
      } finally {
        setIsLoading(false);
      }
    },
    [onSubmit, close]
  );
  return {
    openModalTakeOver,
    closeModalTakeOver: close,
    modalTakeOverData: data,
    modalTakeOverState: modal,
    isLoadingTakeOver: isLoading,
    onSubmitModalTakeOver: handleSubmitModalTakeOver
  };
};
var EnquiryContext = createContext({
  data: null,
  action: null
});
var EnquiryProvider = ({
  children,
  onFetchLocationSuggestion,
  locationUrl,
  encryptionUrl,
  language = "id"
}) => {
  const [isSuccessOTP, setSuccessOTP] = useState(false);
  useEffect(() => {
    if (!isSuccessOTP)
      return;
    setTimeout(() => {
      setSuccessOTP(false);
    }, 1500);
  }, [isSuccessOTP]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalSuccess, setModalSuccess] = useState({
    open: false,
    title: "",
    subTitle: ""
  });
  const [enquiryData, setEnquiryData] = useCookiesState(
    OTP_ENQUIRY_COOKIE_KEY,
    DEFAULT_OTP_ENQUIRY_COOKIE_VALUE,
    ENQUIRY_COOKIES_EXPIRE_DURATION
  );
  const {
    state: enquiryMain,
    updateStateWithCallbackModifier: setEnquiryMain
  } = useCookieStateWithEncryption(
    OTP_ENQUIRY_MAIN_COOKIE_KEY,
    DEFAULT_ENQUIRY_MAIN_COOKIE_VALUE,
    ENQUIRY_COOKIES_EXPIRE_DURATION,
    encryptionUrl
  );
  const {
    state: enquiryMortgageDetail,
    updateStateWithCallbackModifier: setEnquiryMortgageDetail
  } = useStorageStateWithEncryption(
    OTP_MORTGAGE_ENQUIRY_COOKIE_KEY,
    DEFAULT_MORTGAGE_ENQUIRY_COOKIE_VALUE,
    encryptionUrl
  );
  const {
    openModalBasic,
    modalBasicData,
    modalBasicState,
    isLoadingBasic,
    onSubmitModalBasic
  } = useModalBasic();
  const {
    openModalQuestionBasic,
    isLoadingQuestionBasic,
    modalBasicQuestionData,
    modalBasicQuestionState,
    onSubmitModalQuestionBasic
  } = useModalQuestionBasic();
  const {
    isLoadingTakeOver,
    modalTakeOverData,
    modalTakeOverState,
    onSubmitModalTakeOver,
    openModalTakeOver
  } = useModalTakeOver();
  const {
    openModalEntryPoint,
    modalEntryPointData,
    modalEntryPointState,
    isLoadingEntryPoint,
    onSubmitModalEntryPoint
  } = useModalEntryPoint();
  const {
    openModalStepOne,
    modalStepOneData,
    modalStepOneState,
    isLoadingStepOne,
    onSubmitModalStepOne
  } = useModalStepOne();
  const {
    openModalStepTwo,
    modalStepTwoData,
    modalStepTwoState,
    isLoadingStepTwo,
    onSubmitModalStepTwo
  } = useModalStepTwo();
  const getEnquiryDataDirectlyFromCookie = () => {
    try {
      const enquiryDataRaw = getCookie(OTP_ENQUIRY_COOKIE_KEY) || "null";
      const enquiryData2 = JSON.parse(
        enquiryDataRaw
      );
      if (!enquiryData2)
        return null;
      return {
        isVerified: enquiryData2?.isVerified || false,
        name: enquiryData2?.name,
        phoneNumber: enquiryData2?.phoneNumber
      };
    } catch (_) {
      return null;
    }
  };
  const checkFormOneExpired = () => {
    const formOneExpireAt = enquiryMortgageDetail.formOneExpireAt;
    if (!formOneExpireAt)
      return false;
    return Date.now() > formOneExpireAt;
  };
  const toggleLoading = () => {
    setIsLoading((c) => !c);
  };
  const toggleSuccessOTP = () => {
    setSuccessOTP((c) => !c);
  };
  const startModalEntryPoint = async ({
    onSubmit,
    title,
    initForm
  }) => {
    const enquiryDataFromCookie = getEnquiryDataDirectlyFromCookie();
    const isVerified = enquiryDataFromCookie?.isVerified;
    const name = enquiryMain.name || enquiryDataFromCookie?.name;
    const phoneNumber = enquiryMain.phoneNumber || enquiryDataFromCookie?.phoneNumber;
    const data = await openModalEntryPoint({
      data: {
        initForm: isVerified ? {
          name: initForm?.name || name,
          phoneNumber: initForm?.phoneNumber || phoneNumber
        } : {
          name: initForm?.name,
          phoneNumber: initForm?.phoneNumber
        },
        title
      },
      onSubmit
    });
    return data;
  };
  const startModalFormOne = async ({
    onSubmit,
    initForm,
    bankSlug = "kpr-rumah123"
  }) => {
    const isExpired = checkFormOneExpired();
    const isPrefill = isExpired && enquiryMortgageDetail.formOneExpiryByBank?.[bankSlug];
    const data = await openModalStepOne({
      data: {
        initForm: isPrefill ? {
          desiredProperty: initForm?.desiredProperty || enquiryMortgageDetail.desiredProperty,
          eta: initForm?.eta || enquiryMortgageDetail.eta,
          propertyPrice: initForm?.propertyPrice || enquiryMortgageDetail.propertyPrice,
          location: initForm?.location || {
            city: enquiryMortgageDetail.location?.city,
            province: enquiryMortgageDetail.location?.province,
            district: enquiryMortgageDetail.location?.district,
            title: enquiryMortgageDetail.location?.title
          }
        } : {
          desiredProperty: initForm?.desiredProperty || "",
          eta: initForm?.eta || "",
          propertyPrice: initForm?.propertyPrice,
          location: initForm?.location
        }
      },
      onSubmit
    });
    if (!data)
      return;
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1e3;
    await updateEnquiryMortgageDetail({
      ...data,
      formOneExpireAt: Date.now() + thirtyDaysInMs,
      formOneExpiryByBank: enquiryMortgageDetail.formOneExpiryByBank ? {
        ...enquiryMortgageDetail.formOneExpiryByBank,
        [bankSlug]: Date.now() + thirtyDaysInMs
      } : { [bankSlug]: Date.now() + thirtyDaysInMs },
      isCompleteStepTwo: false
    });
    return data;
  };
  const startModalFormTwo = async ({
    onSubmit,
    buttonText,
    initForm
  }) => {
    const data = await openModalStepTwo({
      data: { buttonText, initForm },
      onSubmit
    });
    if (!data) {
      await updateEnquiryMortgageDetail({
        jobType: "",
        jobStatus: "",
        salary: void 0,
        workLength: void 0,
        isCompleteStepTwo: false
      });
      return;
    }
    await updateEnquiryMortgageDetail({
      ...data,
      isCompleteStepTwo: true
    });
    return data;
  };
  const startModalBasic = async ({
    onSubmit,
    initForm,
    title
  }) => {
    const enquiryDataFromCookie = getEnquiryDataDirectlyFromCookie();
    const isVerified = enquiryDataFromCookie?.isVerified;
    const name = enquiryMain.name || enquiryDataFromCookie?.name;
    const phoneNumber = enquiryMain.phoneNumber || enquiryDataFromCookie?.phoneNumber;
    return openModalBasic({
      data: {
        initForm: isVerified ? {
          name: initForm?.name || name,
          phoneNumber: initForm?.phoneNumber || phoneNumber
        } : {
          name: initForm?.name,
          phoneNumber: initForm?.phoneNumber
        },
        title
      },
      onSubmit
    });
  };
  const startModalBasicQuestion = async ({
    onSubmit,
    initForm,
    title
  }) => {
    const enquiryDataFromCookie = getEnquiryDataDirectlyFromCookie();
    const isVerified = enquiryDataFromCookie?.isVerified;
    const name = enquiryMain.name || enquiryDataFromCookie?.name;
    const phoneNumber = enquiryMain.phoneNumber || enquiryDataFromCookie?.phoneNumber;
    return openModalQuestionBasic({
      data: {
        initForm: isVerified ? {
          name: initForm?.name || name,
          phoneNumber: initForm?.phoneNumber || phoneNumber
        } : {
          name: initForm?.name,
          phoneNumber: initForm?.phoneNumber
        },
        title
      },
      onSubmit
    });
  };
  const startModalTakeOver = async ({
    onSubmit,
    initForm,
    title
  }) => {
    const enquiryDataFromCookie = getEnquiryDataDirectlyFromCookie();
    const isVerified = enquiryDataFromCookie?.isVerified;
    const name = enquiryMain.name || enquiryDataFromCookie?.name;
    const phoneNumber = enquiryMain.phoneNumber || enquiryDataFromCookie?.phoneNumber;
    return openModalTakeOver({
      data: {
        initForm: isVerified ? {
          name: initForm?.name || name,
          phoneNumber: initForm?.phoneNumber || phoneNumber
        } : {
          name: initForm?.name,
          phoneNumber: initForm?.phoneNumber
        },
        title
      },
      onSubmit
    });
  };
  const showModalSuccess = (data) => {
    setModalSuccess((c) => {
      return {
        ...c,
        ...data,
        open: true
      };
    });
  };
  const hideModalSuccess = () => {
    setModalSuccess((c) => {
      return {
        ...c,
        open: false
      };
    });
  };
  const updateEnquiryMain = async (data) => {
    await setEnquiryMain((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const updateEnquiryMortgageDetail = async (data) => {
    await setEnquiryMortgageDetail((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const updateEnquiryData = (data) => {
    setEnquiryData((c) => {
      return {
        ...c,
        ...data
      };
    });
  };
  const addBank = async (bank) => {
    await setEnquiryMortgageDetail((c) => {
      const currentBanks = [...c.banks || []];
      if (currentBanks.includes(bank))
        return c;
      currentBanks.push(bank);
      return {
        ...c,
        banks: currentBanks
      };
    });
  };
  const checkIfAlreadyEnquiryToBank = (bank) => {
    return (enquiryMortgageDetail.banks || []).includes(bank);
  };
  const getAuthTrackerPayload = (authProfile) => {
    if (!authProfile)
      return {
        user_type: "Consumer",
        user_id: ""
      };
    return {
      user_id: +authProfile.user_type === 0 ? authProfile.uuid : authProfile.origin_id,
      user_type: +authProfile.user_type === 0 ? "Consumer" : "Agent"
    };
  };
  const startMortgageFlow = async ({
    newEntryPoint,
    bankSlug = "kpr-rumah123",
    authenticate,
    onSubmitEachStep,
    successTitle,
    successSubTitle,
    initFormOne
  }) => {
    let currentMortgageUuid = enquiryMortgageDetail.uuidByBank?.[bankSlug] || "";
    let mortgageUuidResponse = void 0;
    let authTrackerPaylod = {
      user_type: ""
    };
    if (!enquiryMain.isVerified) {
      const entryPointData = await startModalEntryPoint({
        title: newEntryPoint
      });
      if (!entryPointData) {
        return {
          currentStep: "ENTRY_POINT" /* ENTRY_POINT */
        };
      }
      const userData = {
        name: entryPointData.name,
        phoneNumber: entryPointData.phoneNumber,
        isVerified: true
      };
      const dataOnSubmitEntryPoint = {
        ...userData,
        desiredProperty: entryPointData.desiredProperty,
        eta: entryPointData.eta,
        isVerified: false
      };
      mortgageUuidResponse = await onSubmitEachStep({
        currentStep: "ENTRY_POINT" /* ENTRY_POINT */,
        data: dataOnSubmitEntryPoint,
        trackerPayload: {
          ...getTrackerPayload(dataOnSubmitEntryPoint),
          ...authTrackerPaylod
        },
        corePayload: getCorePayload(dataOnSubmitEntryPoint),
        zapierPayload: getZapierPayload(dataOnSubmitEntryPoint)
      });
      if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
        currentMortgageUuid = mortgageUuidResponse;
        await updateEnquiryMortgageDetail({
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        });
      }
      const [authProfile, cookieOTP] = await authenticate({
        name: userData.name,
        phoneNumber: userData.phoneNumber
      });
      authTrackerPaylod = getAuthTrackerPayload(authProfile);
      if (!authProfile && !cookieOTP) {
        return {
          currentStep: entryPointData.isLowIntent ? "VERIFY_OTP_LOW_INTENT" /* VERIFY_OTP_LOW_INTENT */ : "VERIFY_OTP" /* VERIFY_OTP */,
          data: dataOnSubmitEntryPoint
        };
      }
      const onSubmitData = {
        ...userData,
        desiredProperty: entryPointData.desiredProperty,
        eta: entryPointData.eta,
        uuid: currentMortgageUuid,
        uuidByBank: {
          ...enquiryMortgageDetail.uuidByBank,
          [bankSlug]: currentMortgageUuid
        }
      };
      mortgageUuidResponse = await onSubmitEachStep({
        currentStep: entryPointData.isLowIntent ? "VERIFY_OTP_LOW_INTENT" /* VERIFY_OTP_LOW_INTENT */ : "VERIFY_OTP" /* VERIFY_OTP */,
        data: onSubmitData,
        trackerPayload: {
          ...getTrackerPayload(onSubmitData),
          ...authTrackerPaylod
        },
        corePayload: getCorePayload(onSubmitData),
        zapierPayload: getZapierPayload(onSubmitData)
      });
      if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
        currentMortgageUuid = mortgageUuidResponse;
        await updateEnquiryMortgageDetail({
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        });
      }
      updateEnquiryData({ ...userData });
      await updateEnquiryMain({ ...userData });
      await updateEnquiryMortgageDetail({
        desiredProperty: entryPointData.desiredProperty,
        eta: entryPointData.eta
      });
      const isAlreadyEnquiryToThisBank2 = bankSlug ? checkIfAlreadyEnquiryToBank(bankSlug) : true;
      if (!isAlreadyEnquiryToThisBank2 && bankSlug) {
        addBank(bankSlug);
      }
      if (entryPointData.isLowIntent) {
        showModalSuccess({
          title: successTitle,
          subTitle: successSubTitle
        });
        return {
          currentStep: "FINISH" /* FINISH */,
          data: {
            ...userData,
            ...entryPointData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          }
        };
      }
      setSuccessOTP(true);
      const modalFormOneData = await startModalFormOne({
        onSubmit: async (formOneData) => {
          const onSubmitData2 = {
            ...userData,
            ...formOneData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          };
          mortgageUuidResponse = await onSubmitEachStep({
            currentStep: "FORM_ONE" /* FORM_ONE */,
            data: onSubmitData2,
            trackerPayload: {
              ...getTrackerPayload(onSubmitData2),
              ...authTrackerPaylod
            },
            corePayload: getCorePayload(onSubmitData2),
            zapierPayload: getZapierPayload(onSubmitData2)
          });
          if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
            currentMortgageUuid = mortgageUuidResponse;
            await updateEnquiryMortgageDetail({
              uuid: currentMortgageUuid,
              uuidByBank: {
                ...enquiryMortgageDetail.uuidByBank,
                [bankSlug]: currentMortgageUuid
              }
            });
          }
        },
        initForm: {
          desiredProperty: entryPointData.desiredProperty || "Sudah",
          eta: entryPointData.eta,
          propertyPrice: initFormOne?.propertyPrice,
          location: initFormOne?.location
        },
        bankSlug
      });
      if (!modalFormOneData) {
        return {
          currentStep: "FORM_ONE" /* FORM_ONE */,
          data: {
            ...userData,
            desiredProperty: entryPointData.desiredProperty,
            eta: entryPointData.eta,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          }
        };
      }
      const modalFormTwoData = await startModalFormTwo({
        onSubmit: async (formTwoData) => {
          const onSubmitData2 = {
            ...userData,
            ...modalFormOneData,
            ...formTwoData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          };
          mortgageUuidResponse = await onSubmitEachStep({
            currentStep: "FORM_TWO" /* FORM_TWO */,
            data: onSubmitData2,
            trackerPayload: {
              ...getTrackerPayload(onSubmitData2),
              ...authTrackerPaylod
            },
            corePayload: getCorePayload(onSubmitData2),
            zapierPayload: getZapierPayload(onSubmitData2)
          });
          if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
            currentMortgageUuid = mortgageUuidResponse;
            await updateEnquiryMortgageDetail({
              uuid: currentMortgageUuid,
              uuidByBank: {
                ...enquiryMortgageDetail.uuidByBank,
                [bankSlug]: currentMortgageUuid
              }
            });
          }
        },
        buttonText: newEntryPoint
      });
      if (!modalFormTwoData) {
        return {
          currentStep: "FORM_TWO" /* FORM_TWO */,
          data: {
            ...userData,
            ...modalFormOneData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          }
        };
      }
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      return {
        currentStep: "FINISH" /* FINISH */,
        data: {
          ...userData,
          ...modalFormOneData,
          ...modalFormTwoData,
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        }
      };
    }
    const isFormOneExpired = checkFormOneExpired();
    if (enquiryMortgageDetail.uuidByBank?.[bankSlug] !== currentMortgageUuid) {
      enquiryMortgageDetail.uuidByBank?.[bankSlug];
      await updateEnquiryMortgageDetail({
        uuid: currentMortgageUuid,
        uuidByBank: {
          ...enquiryMortgageDetail.uuidByBank,
          [bankSlug]: currentMortgageUuid
        }
      });
    }
    if (!enquiryMortgageDetail.isCompleteStepTwo && isFormOneExpired || !enquiryMortgageDetail.formOneExpireAt) {
      const modalFormOneData = await startModalFormOne({
        onSubmit: async (formOneData) => {
          const onSubmitData = {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            desiredProperty: formOneData.desiredProperty,
            eta: formOneData.eta,
            location: formOneData.location,
            propertyPrice: formOneData.propertyPrice,
            // return uuid if user has not fill form one
            uuid: !enquiryMortgageDetail.formOneExpireAt ? currentMortgageUuid : void 0
          };
          mortgageUuidResponse = await onSubmitEachStep({
            currentStep: "FORM_ONE" /* FORM_ONE */,
            data: onSubmitData,
            trackerPayload: {
              ...getTrackerPayload(onSubmitData),
              ...authTrackerPaylod
            },
            corePayload: getCorePayload(onSubmitData),
            zapierPayload: getZapierPayload(onSubmitData)
          });
          if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
            currentMortgageUuid = mortgageUuidResponse;
            await updateEnquiryMortgageDetail({
              uuid: currentMortgageUuid,
              uuidByBank: {
                ...enquiryMortgageDetail.uuidByBank,
                [bankSlug]: currentMortgageUuid
              }
            });
          }
        },
        initForm: {
          desiredProperty: enquiryMortgageDetail.desiredProperty || "Sudah",
          eta: enquiryMortgageDetail.eta,
          propertyPrice: initFormOne?.propertyPrice || enquiryMortgageDetail.propertyPrice,
          location: initFormOne?.location || enquiryMortgageDetail.location
        },
        bankSlug
      });
      if (!modalFormOneData) {
        return {
          currentStep: "FORM_ONE" /* FORM_ONE */,
          data: {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            eta: enquiryMortgageDetail.eta,
            desiredProperty: enquiryMortgageDetail.desiredProperty,
            uuid: void 0,
            uuidByBank: {}
          }
        };
      }
      const isAlreadyEnquiryToThisBank2 = bankSlug ? checkIfAlreadyEnquiryToBank(bankSlug) : true;
      if (!isAlreadyEnquiryToThisBank2 && bankSlug) {
        addBank(bankSlug);
      }
      const modalFormTwoData = await startModalFormTwo({
        onSubmit: async (formTwoData) => {
          const onSubmitData = {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            ...modalFormOneData,
            ...formTwoData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          };
          mortgageUuidResponse = await onSubmitEachStep({
            currentStep: "FORM_TWO" /* FORM_TWO */,
            data: onSubmitData,
            trackerPayload: {
              ...getTrackerPayload(onSubmitData),
              ...authTrackerPaylod
            },
            corePayload: getCorePayload(onSubmitData),
            zapierPayload: getZapierPayload(onSubmitData)
          });
          if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
            currentMortgageUuid = mortgageUuidResponse;
            await updateEnquiryMortgageDetail({
              uuid: currentMortgageUuid,
              uuidByBank: {
                ...enquiryMortgageDetail.uuidByBank,
                [bankSlug]: currentMortgageUuid
              }
            });
          }
        },
        buttonText: newEntryPoint
      });
      if (!modalFormTwoData) {
        return {
          currentStep: "FORM_TWO" /* FORM_TWO */,
          data: {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            ...modalFormOneData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          }
        };
      }
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      return {
        currentStep: "FINISH" /* FINISH */,
        data: {
          name: enquiryMain.name,
          phoneNumber: enquiryMain.phoneNumber,
          ...modalFormOneData,
          ...modalFormTwoData,
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        }
      };
    }
    const isAlreadyEnquiryToThisBank = bankSlug ? checkIfAlreadyEnquiryToBank(bankSlug) : true;
    if (!enquiryMortgageDetail.isCompleteStepTwo) {
      const modalFormTwoData = await startModalFormTwo({
        onSubmit: async (formTwoData) => {
          const onSubmitData = {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            desiredProperty: enquiryMortgageDetail.desiredProperty,
            eta: enquiryMortgageDetail.eta,
            location: enquiryMortgageDetail.location,
            propertyPrice: enquiryMortgageDetail.propertyPrice,
            ...formTwoData,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          };
          mortgageUuidResponse = await onSubmitEachStep({
            currentStep: "FORM_TWO" /* FORM_TWO */,
            data: onSubmitData,
            trackerPayload: {
              ...getTrackerPayload(onSubmitData),
              ...authTrackerPaylod
            },
            corePayload: getCorePayload(onSubmitData),
            zapierPayload: getZapierPayload(onSubmitData)
          });
          if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
            currentMortgageUuid = mortgageUuidResponse;
            await updateEnquiryMortgageDetail({
              uuid: currentMortgageUuid,
              uuidByBank: {
                ...enquiryMortgageDetail.uuidByBank,
                [bankSlug]: currentMortgageUuid
              }
            });
          }
        },
        buttonText: newEntryPoint
      });
      if (!modalFormTwoData) {
        return {
          currentStep: "FORM_TWO" /* FORM_TWO */,
          data: {
            name: enquiryMain.name,
            phoneNumber: enquiryMain.phoneNumber,
            desiredProperty: enquiryMortgageDetail.desiredProperty,
            eta: enquiryMortgageDetail.eta,
            location: enquiryMortgageDetail.location,
            propertyPrice: enquiryMortgageDetail.propertyPrice,
            uuid: currentMortgageUuid,
            uuidByBank: {
              ...enquiryMortgageDetail.uuidByBank,
              [bankSlug]: currentMortgageUuid
            }
          }
        };
      }
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      if (!isAlreadyEnquiryToThisBank && bankSlug) {
        addBank(bankSlug);
      }
      return {
        currentStep: "FINISH" /* FINISH */,
        data: {
          name: enquiryMain.name,
          phoneNumber: enquiryMain.phoneNumber,
          desiredProperty: enquiryMortgageDetail.desiredProperty,
          eta: enquiryMortgageDetail.eta,
          location: enquiryMortgageDetail.location,
          propertyPrice: enquiryMortgageDetail.propertyPrice,
          ...modalFormTwoData,
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        }
      };
    }
    if (enquiryMortgageDetail.isCompleteStepTwo) {
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      const finalData = {
        name: enquiryMain.name,
        phoneNumber: enquiryMain.phoneNumber,
        desiredProperty: enquiryMortgageDetail.desiredProperty,
        eta: enquiryMortgageDetail.eta,
        location: enquiryMortgageDetail.location,
        propertyPrice: enquiryMortgageDetail.propertyPrice,
        jobStatus: enquiryMortgageDetail.jobStatus,
        jobType: enquiryMortgageDetail.jobType,
        workLength: enquiryMortgageDetail.workLength,
        salary: enquiryMortgageDetail.salary,
        uuid: isAlreadyEnquiryToThisBank ? currentMortgageUuid : void 0
      };
      mortgageUuidResponse = await onSubmitEachStep({
        currentStep: isAlreadyEnquiryToThisBank ? "AUTO_SUCCESS" /* AUTO_SUCCESS */ : "AUTO_SUCCESS_WITH_DIFFERENT_BANKS" /* AUTO_SUCCESS_WITH_DIFFERENT_BANKS */,
        data: finalData,
        trackerPayload: {
          ...getTrackerPayload(finalData),
          ...authTrackerPaylod
        },
        corePayload: getCorePayload(finalData),
        zapierPayload: getZapierPayload(finalData)
      });
      if (!isAlreadyEnquiryToThisBank && bankSlug) {
        addBank(bankSlug);
      }
      if (mortgageUuidResponse && mortgageUuidResponse !== currentMortgageUuid) {
        currentMortgageUuid = mortgageUuidResponse;
        await updateEnquiryMortgageDetail({
          uuid: currentMortgageUuid,
          uuidByBank: {
            ...enquiryMortgageDetail.uuidByBank,
            [bankSlug]: currentMortgageUuid
          }
        });
      }
      return {
        currentStep: "FINISH" /* FINISH */,
        data: finalData
      };
    }
    console.error("Not implemented");
  };
  const startMortgageFlowBasic = async ({
    bankSlug,
    title,
    authenticate,
    successTitle,
    successSubTitle,
    onSubmit
  }) => {
    let authTrackerPaylod = {
      user_type: "Consumer",
      user_id: ""
    };
    const isAlreadyEnquiryToThisBank = bankSlug ? checkIfAlreadyEnquiryToBank(bankSlug) : true;
    if (enquiryMain.isVerified && isAlreadyEnquiryToThisBank) {
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      return {
        currentSteps: "AUTO_SUCCESS" /* AUTO_SUCCESS */,
        data: {
          name: enquiryData.name,
          phoneNumber: enquiryMain.phoneNumber
        }
      };
    }
    const data = await startModalBasic({
      title,
      onSubmit
    });
    if (!data) {
      return {
        currentSteps: "BASIC_FORM" /* BASIC_FORM */
      };
    }
    const [authProfile, cookie] = await authenticate({
      name: data.name,
      phoneNumber: data.phoneNumber
    });
    authTrackerPaylod = getAuthTrackerPayload(authProfile);
    if (!authProfile && !cookie) {
      return {
        currentSteps: "VERIFY_OTP" /* VERIFY_OTP */,
        data
      };
    }
    await updateEnquiryMain({
      name: data.name,
      phoneNumber: data.phoneNumber,
      isVerified: true
    });
    updateEnquiryData({
      name: data.name,
      phoneNumber: data.phoneNumber,
      isVerified: true
    });
    if (!isAlreadyEnquiryToThisBank && bankSlug) {
      addBank(bankSlug);
    }
    showModalSuccess({
      title: successTitle,
      subTitle: successSubTitle
    });
    return {
      currentSteps: "FINISH" /* FINISH */,
      data,
      authTrackerPaylod
    };
  };
  const startMortgageTakeOver = async ({
    bankSlug,
    title,
    authenticate,
    successTitle,
    successSubTitle,
    onSubmit
  }) => {
    let authTrackerPaylod = {
      user_type: "",
      user_id: ""
    };
    const isAlreadyEnquiryToThisBank = bankSlug ? checkIfAlreadyEnquiryToBank(bankSlug) : true;
    if (enquiryMain.isVerified && isAlreadyEnquiryToThisBank) {
      showModalSuccess({
        title: successTitle,
        subTitle: successSubTitle
      });
      return {
        currentSteps: "AUTO_SUCCESS" /* AUTO_SUCCESS */,
        data: {
          name: enquiryData.name,
          phoneNumber: enquiryMain.phoneNumber,
          salary: enquiryMortgageDetail.salary || 0
        },
        authTrackerPaylod
      };
    }
    const data = await startModalTakeOver({
      title,
      onSubmit
    });
    if (!data) {
      return {
        currentSteps: "BASIC_FORM" /* BASIC_FORM */
      };
    }
    const [authProfile, cookie] = await authenticate({
      name: data.name,
      phoneNumber: data.phoneNumber
    });
    authTrackerPaylod = getAuthTrackerPayload(authProfile);
    if (!authProfile && !cookie) {
      return {
        currentSteps: "VERIFY_OTP" /* VERIFY_OTP */,
        data
      };
    }
    await updateEnquiryMain({
      name: data.name,
      phoneNumber: data.phoneNumber,
      isVerified: true
    });
    await updateEnquiryMortgageDetail({
      salary: data.salary
    });
    updateEnquiryData({
      name: data.name,
      phoneNumber: data.phoneNumber,
      isVerified: true
    });
    if (!isAlreadyEnquiryToThisBank && bankSlug) {
      addBank(bankSlug);
    }
    showModalSuccess({
      title: successTitle,
      subTitle: successSubTitle
    });
    return {
      currentSteps: "FINISH" /* FINISH */,
      data,
      authTrackerPaylod
    };
  };
  const value = {
    data: {
      isLoading,
      enquiryData,
      enquiryMain,
      enquiryMortgageDetail
    },
    action: {
      toggleLoading,
      toggleSuccessOTP,
      startModalEntryPoint,
      startModalFormOne,
      startModalFormTwo,
      startModalBasic,
      startMortgageTakeOver,
      startModalBasicQuestion,
      updateEnquiryMain,
      updateEnquiryMortgageDetail,
      // will show form two if form one is not expired yet
      checkFormOneExpired,
      // this is temporary helper, if we deleted
      // the enquiry_data then this method wont be needed
      getEnquiryDataDirectlyFromCookie,
      updateEnquiryData,
      addBank,
      checkIfAlreadyEnquiryToBank,
      showModalSuccess,
      hideModalSuccess,
      startMortgageFlow,
      startMortgageFlowBasic
    }
  };
  const firstName = (enquiryMain?.name || "")?.split(" ")[0];
  return /* @__PURE__ */ jsxs(EnquiryContext.Provider, { value, children: [
    isSuccessOTP && /* @__PURE__ */ jsx(SuccessAlert, { children: language === "id" ? "OTP Berhasil" : "OTP Success" }),
    children,
    /* @__PURE__ */ jsxs(ReactPortalComponent, { children: [
      /* @__PURE__ */ jsx(
        ModalEntryPoint,
        {
          ...modalEntryPointData || {},
          ...modalEntryPointState,
          isLoading: isLoadingEntryPoint,
          onSubmit: onSubmitModalEntryPoint,
          language
        },
        modalEntryPointState.open ? "show-entry" : "hide-entry"
      ),
      /* @__PURE__ */ jsx(
        ModalFormStepOne,
        {
          onFetchLocationSuggestion,
          locationUrl,
          ...modalStepOneState,
          ...modalStepOneData || {},
          firstName,
          isLoading: isLoadingStepOne,
          onSubmit: onSubmitModalStepOne,
          language
        },
        modalStepOneState.open ? "show-one" : "hide-one"
      ),
      /* @__PURE__ */ jsx(
        ModalFormStepTwo,
        {
          ...modalStepTwoState,
          ...modalStepTwoData || {},
          firstName,
          isLoading: isLoadingStepTwo,
          onSubmit: onSubmitModalStepTwo,
          language
        },
        modalStepTwoState.open ? "show-two" : "hide-two"
      ),
      /* @__PURE__ */ jsx(
        ModalBasic,
        {
          ...modalBasicData || {},
          ...modalBasicState,
          isLoading: isLoadingBasic,
          onSubmit: onSubmitModalBasic,
          language
        },
        modalBasicState.open ? "show-basic" : "hide-basic"
      ),
      /* @__PURE__ */ jsx(
        ModalBaseWithQuestion,
        {
          ...modalBasicQuestionData || {},
          ...modalBasicQuestionState,
          isLoading: isLoadingQuestionBasic,
          onSubmit: onSubmitModalQuestionBasic,
          language
        },
        modalBasicQuestionState.open ? "show-question" : "hide-question"
      ),
      /* @__PURE__ */ jsx(
        ModalTakeOver_default,
        {
          ...modalTakeOverData || {},
          ...modalTakeOverState,
          isLoading: isLoadingTakeOver,
          onSubmit: onSubmitModalTakeOver
        },
        modalTakeOverState.open ? "show-take-over" : "hide-take-over"
      ),
      /* @__PURE__ */ jsx(
        ModalSuccess,
        {
          className: "md:w-[375px]",
          ...modalSuccess,
          onClose: () => {
            setModalSuccess((c) => {
              return {
                ...c,
                open: false
              };
            });
          }
        }
      )
    ] })
  ] });
};
var useEnquiryProviderV3 = () => {
  return useContext(EnquiryContext);
};

// src/zapier.types.ts
var ZapierMortgageTargetSpreadsheetEnum = /* @__PURE__ */ ((ZapierMortgageTargetSpreadsheetEnum2) => {
  ZapierMortgageTargetSpreadsheetEnum2["KemampuanKpr"] = "Kemampuan KPR";
  ZapierMortgageTargetSpreadsheetEnum2["KelayakanKpr"] = "Kelayakan KPR";
  ZapierMortgageTargetSpreadsheetEnum2["SimulasiKpr"] = "Simulasi KPR";
  ZapierMortgageTargetSpreadsheetEnum2["BankHomePage"] = "Bank Home Page";
  ZapierMortgageTargetSpreadsheetEnum2["TakeoverHomePage"] = "Takeover Home Page";
  ZapierMortgageTargetSpreadsheetEnum2["TakeoverBankLandingPage"] = "Takeover Bank Landing Page";
  ZapierMortgageTargetSpreadsheetEnum2["BankLandingPage"] = "Bank Landing Page";
  ZapierMortgageTargetSpreadsheetEnum2["MultigunaLandingPage"] = "Multiguna Landing Page";
  ZapierMortgageTargetSpreadsheetEnum2["SyariahKpr"] = "Syariah KPR";
  ZapierMortgageTargetSpreadsheetEnum2["Freemium"] = "Freemium";
  return ZapierMortgageTargetSpreadsheetEnum2;
})(ZapierMortgageTargetSpreadsheetEnum || {});

export { DEFAULT_OTP_ENQUIRY_COOKIE_VALUE, ENQUIRY_COOKIES_EXPIRE_DURATION, EnquiryProviderV2, EnquiryProvider as EnquiryProviderV3, Loader_default as Loader, ModalBaseBasic, ModalBaseData, ModalBaseWithEmail, ModalBaseWithQuestion, ModalBaseWithSalary, ModalBasic, ModalChangePhoneNumber, ModalDetailData, ModalEnquiryRenovation, ModalEntryPoint, ModalFormStepOne, ModalFormStepTwo, ModalOTP, ModalSuccess, ModalTakeOver_default as ModalTakeOver, OTP_ENQUIRY_COOKIE_KEY, OTP_NUMBER_LENGTH, PhoneInputList_default as PhoneList, SuccessAlert, ZapierMortgageTargetSpreadsheetEnum, cleanPrefixFromPhoneNumber, constructUrl, requestOtp, useEnquiryProviderV3, useEnquiryV2, useOtp, verifyOtp };
